import React, { useState, useEffect } from 'react';
import { Search, Trash2, Edit, Plus, Save, X, User, DollarSign, Calendar, Phone, Mail, FileText, TrendingDown, TrendingUp, Camera, Upload, Clock, CheckCircle, AlertCircle, CreditCard, BarChart3, Users, Wallet, PieChart, Minus, Gift } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import config from '../config';
import axios from 'axios';
import usePermissions from './usePermissions';
import { useMemo, useCallback, memo } from 'react';



const EmployeeManagement = () => {
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();
  const canDo = (permission) => hasPermission('حسابات الموظفين - الصلاحيات', permission);
    const [paymentMethods, setPaymentMethods] = useState([]);

  const [employees, setEmployees] = useState([]);
  const [showEmployeeForm, setShowEmployeeForm] = useState(false);
  const [showTransactionForm, setShowTransactionForm] = useState(false);
  const [showAdvanceForm, setShowAdvanceForm] = useState(false);
  const [showInstallmentForm, setShowInstallmentForm] = useState(false);
  const [showEditAdvanceForm, setShowEditAdvanceForm] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [advances, setAdvances] = useState([]);
  const [search, setSearch] = useState('');
  const [activeTab, setActiveTab] = useState('employees');
  const [salaryReport, setSalaryReport] = useState([]);
  const [reportMonth, setReportMonth] = useState(new Date().getMonth() + 1);
  const [reportYear, setReportYear] = useState(new Date().getFullYear());
  const [loading, setLoading] = useState(true);

const [isSubmitting, setIsSubmitting] = useState(false);


const [allTransactionsData, setAllTransactionsData] = useState({
  transactions: [],
  totalCount: 0,
  hasMore: false,
  currentOffset: 0,
  limit: 10
});
const [searchDebounce, setSearchDebounce] = useState('');
const [isLoadingMore, setIsLoadingMore] = useState(false);




  const [pendingDeductions, setPendingDeductions] = useState({
  pendingDeductions: [],
  totalAmount: 0,
  count: 0
});

// إضافة هذه المتغيرات في بداية الكومبوننت
// إضافة هذه المتغيرات مع باقي useState
const [allTransactions, setAllTransactions] = useState([]);
const [showEditTransactionForm, setShowEditTransactionForm] = useState(false);
const [editingTransaction, setEditingTransaction] = useState(null);
const [transactionSearch, setTransactionSearch] = useState('');
const [transactionFilter, setTransactionFilter] = useState('الكل');
const [dateFilter, setDateFilter] = useState('');
const [employeeFilter, setEmployeeFilter] = useState('الكل');

const [editTransactionFormData, setEditTransactionFormData] = useState({
  transactionId: null,
  employeeId: null,
  transactionType: 'بونص',
  amount: '',
  description: '',
  transactionDate: new Date().toISOString().split('T')[0],
  salaryMonth: new Date().getMonth() + 1,
  salaryYear: new Date().getFullYear()
});




  
  // البيانات الجديدة
  const [statistics, setStatistics] = useState(null);
  const [monthlyStatus, setMonthlyStatus] = useState([]);
  const [overduePayments, setOverduePayments] = useState([]);
  const [statusMonth, setStatusMonth] = useState(new Date().getMonth() + 1);
  const [statusYear, setStatusYear] = useState(new Date().getFullYear());
  const [showSmartSalaryForm, setShowSmartSalaryForm] = useState(false);
  const [employeeHistory, setEmployeeHistory] = useState([]);
  const [smartSalaryData, setSmartSalaryData] = useState({
    employeeId: null,
    suggestedAmount: 0,
    maxAmount: 0
  });

  const [employeeFormData, setEmployeeFormData] = useState({
    employeeName: '',
    position: '',
    basicSalary: '',
    phone: '',
    email: '',
    hireDate: '',
    notes: '',
    profileImage: null
  });
  
 const [transactionFormData, setTransactionFormData] = useState({
    transactionType: 'بونص',
    amount: '',
    description: '',
    transactionDate: new Date().toISOString().split('T')[0],
    salaryMonth: new Date().getMonth() + 1,
    salaryYear: new Date().getFullYear(),
    paymentMethodId: null,
    paymentMethodType: null
  });

 const [advanceFormData, setAdvanceFormData] = useState({
    employeeId: null,
    amount: '',
    description: '',
    installmentAmount: '',
    numberOfInstallments: '',
    startDeductionMonth: new Date().getMonth() + 1,
    startDeductionYear: new Date().getFullYear(),
    isInstallment: false,
    transactionDate: new Date().toISOString().split('T')[0],
    paymentMethodId: null,
    paymentMethodType: null
  });

const [editAdvanceFormData, setEditAdvanceFormData] = useState({
  advanceId: null,
  amount: '',
  paidAmount: 0, // إضافة
  remainingAmount: 0, // إضافة
  description: '',
  installmentAmount: '',
  numberOfInstallments: '',
  startDeductionMonth: new Date().getMonth() + 1,
  startDeductionYear: new Date().getFullYear(),
  isInstallment: false
});

  const [installmentFormData, setInstallmentFormData] = useState({
    advanceId: null,
    amount: '',
    description: '',
    paymentDate: new Date().toISOString().split('T')[0]
  });
  
  const [editingId, setEditingId] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);



// debounce للبحث
useEffect(() => {
  const timer = setTimeout(() => {
    setSearchDebounce(transactionSearch);
  }, 500);

  return () => clearTimeout(timer);
}, [transactionSearch]);

// جلب المعاملات عند تغيير البحث
useEffect(() => {
  if (activeTab === 'all-transactions') {
    fetchAllTransactions(true);
  }
}, [searchDebounce, transactionFilter, employeeFilter, dateFilter]);


  useEffect(() => {
    const abortController = new AbortController();
    
    const fetchData = async () => {
      try {
        await fetchEmployees();
        await fetchPaymentMethods();
        await fetchMonthlyStatus();
        await fetchOverduePayments();
        await fetchStatistics();
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.error('خطأ في جلب البيانات:', error);
        }
      }
    };
    
    fetchData();
    
    return () => {
      abortController.abort();
    };
  }, []);
  // جلب البيانات
  const fetchEmployees = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${config.API_BASE_URL}/api/employees`);
      if (response.ok) {
        const data = await response.json();
        setEmployees(Array.isArray(data) ? data : []);
      } else {
        console.error('خطأ في الاستجابة:', response.status);
        setEmployees([]);
      }
    } catch (error) {
      console.error('خطأ في جلب الموظفين:', error);
      setEmployees([]);
    } finally {
      setLoading(false);
    }
  };


const fetchPaymentMethods = async () => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/api/employees/payment-methods`);
      if (response.ok) {
        const data = await response.json();
        setPaymentMethods(data.paymentMethods || []);
      } else {
        console.error('خطأ في جلب طرق الدفع:', response.status);
        setPaymentMethods([]);
      }
    } catch (error) {
      console.error('خطأ في جلب طرق الدفع:', error);
      setPaymentMethods([]);
    }
  };




  const fetchStatistics = async () => {
    try {
      const month = statusMonth;
      const year = statusYear;
      const response = await fetch(`${config.API_BASE_URL}/api/employees/statistics/${month}/${year}`);
      const data = await response.json();
      setStatistics(data);
    } catch (error) {
      console.error('خطأ في جلب الإحصائيات:', error);
    }
  };

  const fetchTransactions = async (employeeId) => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/api/employees/${employeeId}/transactions`);
      const data = await response.json();
      setTransactions(data);
    } catch (error) {
      console.error('خطأ في جلب المعاملات:', error);
    }
  };

  const fetchAdvances = async (employeeId) => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/api/employees/${employeeId}/advances`);
      const data = await response.json();
      setAdvances(data);
    } catch (error) {
      console.error('خطأ في جلب السلف:', error);
    }
  };

  const fetchEmployeeHistory = async (employeeId) => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/api/employees/${employeeId}/history`);
      const data = await response.json();
      setEmployeeHistory(data);
    } catch (error) {
      console.error('خطأ في جلب تاريخ الموظف:', error);
    }
  };

// في ملف employees.js - تحديث الاستعلام
const fetchMonthlyStatus = async (month = statusMonth, year = statusYear) => {
  try {
    const response = await fetch(`${config.API_BASE_URL}/api/employees/monthly-status/${month}/${year}`);
    if (response.ok) {
      const data = await response.json();
      setMonthlyStatus(Array.isArray(data) ? data : []);
    } else {
      console.error('خطأ في الاستجابة:', response.status);
      setMonthlyStatus([]);
    }
  } catch (error) {
    console.error('خطأ في جلب حالة الموظفين:', error);
    setMonthlyStatus([]);
  }
};

const fetchOverduePayments = async () => {
  try {
    const response = await fetch(`${config.API_BASE_URL}/api/employees/overdue-payments`);
    if (response.ok) {
      const data = await response.json();
      // تأكد من أن البيانات array
      setOverduePayments(Array.isArray(data) ? data : []);
    } else {
      console.error('خطأ في الاستجابة:', response.status);
      setOverduePayments([]);
    }
  } catch (error) {
    console.error('خطأ في جلب الرواتب المتأخرة:', error);
    setOverduePayments([]);
  }
};

  const fetchSalaryReport = async () => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/api/employees/salary-report/${reportMonth}/${reportYear}`);
      const data = await response.json();
      setSalaryReport(data);
    } catch (error) {
      console.error('خطأ في جلب تقرير الرواتب:', error);
    }
  };

  // معالجات النماذج
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setEmployeeFormData({...employeeFormData, profileImage: file});
      
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };



  // دالة تحويل الصورة إلى Base64
const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
};


// في ملف employees.js - تعديل دالة handleEmployeeSubmit
const handleEmployeeSubmit = async (e) => {
  e.preventDefault();
  
  if (isSubmitting) return;
  setIsSubmitting(true);
  
  try {
    let imageBase64 = null;
    
    // تحويل الصورة إلى Base64
    if (employeeFormData.profileImage) {
      imageBase64 = await convertToBase64(employeeFormData.profileImage);
    }

    const requestData = {
      employeeName: employeeFormData.employeeName,
      position: employeeFormData.position,
      basicSalary: employeeFormData.basicSalary,
      phone: employeeFormData.phone,
      email: employeeFormData.email,
      hireDate: employeeFormData.hireDate,
      notes: employeeFormData.notes,
      profileImageBase64: imageBase64 || employeeFormData.currentImageBase64 || null // استخدام الصورة الجديدة أو القديمة
    };

    let response;
    if (editingId) {
      requestData.status = 'نشط';
      response = await fetch(`${config.API_BASE_URL}/api/employees/${editingId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestData)
      });
    } else {
      response = await fetch(`${config.API_BASE_URL}/api/employees`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestData)
      });
    }

    if (response.ok) {
      const result = await response.json();
      alert(editingId ? 'تم تحديث الموظف بنجاح!' : 'تم إضافة الموظف بنجاح!');
      
      await fetchEmployees();
      await fetchMonthlyStatus();
      await fetchStatistics();
      await fetchOverduePayments();
      resetEmployeeForm();
    } else {
      const errorData = await response.json();
      alert('خطأ: ' + (errorData.error || 'حدث خطأ غير متوقع'));
      setIsSubmitting(false);
    }
    
  } catch (error) {
    console.error('خطأ في حفظ الموظف:', error);
    alert('خطأ في الاتصال بالسيرفر');
    setIsSubmitting(false);
  }
};



// في دالة handleTransactionSubmit - تحديث الجزء الخاص بالبونص
const handleTransactionSubmit = async (e) => {
  e.preventDefault();
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    const targetEmployeeId = selectedEmployee?.EmployeeId || transactionFormData.employeeId;
    
    if (!targetEmployeeId) {
      alert('يجب اختيار موظف');
      return;
    }

    // تحديد طريقة الدفع حسب نوع المعاملة
    let paymentData = {};
    
    // للبونص المباشر - مطلوب طريقة دفع
    if (transactionFormData.transactionType === 'بونص' && transactionFormData.bonusType === 'direct') {
      if (!transactionFormData.paymentMethodId) {
        alert('يجب اختيار طريقة الدفع للبونص المباشر');
        return;
      }
      paymentData = {
        paymentMethodId: transactionFormData.paymentMethodId,
        paymentMethodType: transactionFormData.paymentMethodType
      };
    }
    
    // للراتب - طريقة دفع اختيارية
    else if (transactionFormData.transactionType === 'راتب') {
      if (transactionFormData.paymentMethodId) {
        paymentData = {
          paymentMethodId: transactionFormData.paymentMethodId,
          paymentMethodType: transactionFormData.paymentMethodType
        };
      }
    }

    // إعداد البيانات للإرسال
    const requestData = {
      ...transactionFormData,
      createdBy: user.Username,
      ...paymentData
    };

    // إرسال المعاملة
    const response = await fetch(`${config.API_BASE_URL}/api/employees/${targetEmployeeId}/transactions`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestData)
    });

    if (response.ok) {
      const result = await response.json();
      
      // تحديث البيانات
      if (selectedEmployee && selectedEmployee.EmployeeId === targetEmployeeId) {
        fetchTransactions(selectedEmployee.EmployeeId);
        if (activeTab === 'employee-history') {
          fetchEmployeeHistory(selectedEmployee.EmployeeId);
        }
      }
      
      if (activeTab === 'all-transactions') {
        fetchAllTransactions();
      }
      
      fetchMonthlyStatus();
      fetchStatistics();
      fetchOverduePayments();
      resetTransactionForm();
      
      // رسائل مختلفة حسب نوع البونص
      if (transactionFormData.transactionType === 'بونص') {
        if (transactionFormData.bonusType === 'direct') {
          alert('تم دفع البونص مباشرة من البنك بنجاح! لن يُحسب مع الراتب.');
        } else {
          alert('تم إضافة البونص بنجاح. سيتم حسابه مع الراتب التالي.');
        }
      } else if (transactionFormData.transactionType === 'خصم') {
        alert('تم إضافة الخصم بنجاح. سيتم تطبيقه عند دفع الراتب التالي.');
      } else {
        alert(result.message || 'تم إضافة المعاملة بنجاح');
      }
    } else {
      const error = await response.json();
      alert('خطأ: ' + (error.error || 'حدث خطأ غير متوقع'));
    }
    
  } catch (error) {
    console.error('خطأ في إضافة المعاملة:', error);
    alert('خطأ في إضافة المعاملة');
  }
};

const handleAdvanceSubmit = async (e) => {
  e.preventDefault();
  
  // التحقق من وجود طريقة الدفع
  if (!advanceFormData.paymentMethodId) {
    alert('يجب اختيار طريقة الدفع لإضافة السلفة');
    return;
  }
  
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    
    const response = await fetch(`${config.API_BASE_URL}/api/employees/advances`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...advanceFormData,
        createdBy: user.Username
      })
    });
    
    if (response.ok) {
      const result = await response.json();
      
      await fetchAdvances(advanceFormData.employeeId);
      await fetchMonthlyStatus();
      await fetchStatistics();
      await fetchOverduePayments();
      
      if (activeTab === 'all-transactions') {
        await fetchAllTransactions();
      }
      
      resetAdvanceForm();
      alert(result.message || 'تم إضافة السلفة بنجاح مع المزامنة البنكية');
    } else {
      const error = await response.json();
      console.error('خطأ في إضافة السلفة:', error);
      alert('خطأ في إضافة السلفة: ' + (error.error || 'خطأ غير معروف'));
    }
  } catch (error) {
    console.error('خطأ في إضافة السلفة:', error);
    alert('خطأ في إضافة السلفة: ' + error.message);
  }
};

  const handleEditAdvanceSubmit = async (e) => {
    e.preventDefault();
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      const response = await fetch(`${config.API_BASE_URL}/api/employees/advances/${editAdvanceFormData.advanceId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...editAdvanceFormData,
          updatedBy: user.Username
        })
      });

      if (response.ok) {
        await fetchAdvances(selectedEmployee.EmployeeId);
        await fetchMonthlyStatus();
        await fetchStatistics();
        await fetchOverduePayments();
        resetEditAdvanceForm();
      } else {
        const error = await response.json();
        console.error('خطأ في تعديل السلفة:', error);
        alert('خطأ في تعديل السلفة: ' + (error.error || 'خطأ غير معروف'));
      }
    } catch (error) {
      console.error('خطأ في تعديل السلفة:', error);
      alert('خطأ في تعديل السلفة');
    }
  };

  const handleDeleteAdvance = async (advanceId) => {
    if (!window.confirm('هل تريد حذف السلفة؟\nملاحظة: الحذف مسموح فقط إذا لم تُسجَّل عليها أي أقساط/مدفوعات.')) return;
  
    try {
      console.log(`🗑️ بدء حذف السلفة: ${advanceId}`);
  
      const response = await axios.delete(`${config.API_BASE_URL}/api/employees/advances/${advanceId}`, {
        headers: { 'X-Sync-Source': 'employee-frontend' }
      });
  
      if (response.status === 200 && response.data?.success) {
        // تحديث بيانات الموظف
        if (selectedEmployee) {
          await fetchAdvances(selectedEmployee.EmployeeId);
          await fetchTransactions(selectedEmployee.EmployeeId);
        }
        // تحديث لوحات الإحصائيات
        await fetchMonthlyStatus();
        await fetchStatistics();
        await fetchOverduePayments();
  
        // لو التب الحالية "سجل المعاملات" اعمل إعادة تحميل Reset
        if (activeTab === 'all-transactions' && typeof fetchAllTransactions === 'function') {
          await fetchAllTransactions(true);
        }
  
        alert(response.data.message || 'تم حذف السلفة بنجاح');
        return;
      }
  
      alert('استجابة غير متوقعة أثناء حذف السلفة');
    } catch (error) {
      console.error('❌ خطأ في حذف السلفة:', error);
      if (error?.response?.status === 409) {
        alert(error.response.data?.message || 'لا يمكن حذف السلفة لوجود أقساط/مدفوعات مسجّلة.');
        return;
      }
      const msg = error?.response?.data?.error || error.message || 'خطأ غير معروف';
      alert('خطأ في حذف السلفة: ' + msg);
    }
  };
  
  


const fetchAllTransactions = async (reset = false) => {
  try {
    if (reset) {
      setLoading(true);
      setAllTransactionsData({
        transactions: [],
        totalCount: 0,
        hasMore: false,
        currentOffset: 0,
        limit: 10
      });
    } else {
      setIsLoadingMore(true);
    }

    const offset = reset ? 0 : allTransactionsData.currentOffset + allTransactionsData.limit;
    
    // بناء query parameters
    const params = new URLSearchParams({
      limit: '10',
      offset: offset.toString()
    });
    
    if (searchDebounce.trim()) {
      params.append('search', searchDebounce.trim());
    }
    
    const response = await fetch(`${config.API_BASE_URL}/api/employees/all-transactions?${params}`);
    
    if (response.ok) {
      const data = await response.json();
      
      if (reset) {
        setAllTransactionsData(data);
      } else {
        // إضافة البيانات الجديدة للموجودة
        setAllTransactionsData(prev => ({
          ...data,
          transactions: [...prev.transactions, ...data.transactions],
          currentOffset: offset
        }));
      }
    } else {
      console.error('خطأ في الاستجابة:', response.status);
    }
  } catch (error) {
    console.error('خطأ في جلب المعاملات:', error);
  } finally {
    setLoading(false);
    setIsLoadingMore(false);
  }
};


// دالة تحميل المزيد
const loadMoreTransactions = () => {
  if (allTransactionsData.hasMore && !isLoadingMore) {
    fetchAllTransactions(false);
  }
};

// فتح نموذج تعديل المعاملة
const openEditTransactionForm = (transaction) => {
  setEditTransactionFormData({
    transactionId: transaction.TransactionId,
    employeeId: transaction.EmployeeId,
    transactionType: transaction.TransactionType,
    amount: transaction.Amount,
    description: transaction.Description,
    transactionDate: transaction.TransactionDate ? transaction.TransactionDate.split('T')[0] : new Date().toISOString().split('T')[0],
    salaryMonth: transaction.SalaryMonth || new Date().getMonth() + 1,
    salaryYear: transaction.SalaryYear || new Date().getFullYear(),
    paymentMethodId: transaction.PaymentMethodId || null,
    paymentMethodType: transaction.PaymentMethodType || null,
    bonusType: transaction.PaymentMethodId ? 'direct' : 'with_salary' // تحديد نوع البونص بناء على وجود طريقة دفع
  });
  setEditingTransaction(transaction);
  setShowEditTransactionForm(true);
};


// تحديث المعاملة
const handleEditTransactionSubmit = async (e) => {
  e.preventDefault();
  
  // التحقق من طريقة الدفع للبونص
  if (editTransactionFormData.transactionType === 'بونص') {
    if (!editTransactionFormData.bonusType) {
      alert('يرجى اختيار نوع البونص: مع الراتب أم تحويل مباشر');
      return;
    }
    
    if (editTransactionFormData.bonusType === 'direct' && !editTransactionFormData.paymentMethodId) {
      alert('يرجى اختيار طريقة الدفع للبونص المباشر');
      return;
    }
  }
  
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    
    // تحديد إذا كان يحتاج مزامنة بنكية
    const needsBankSync = editTransactionFormData.transactionType === 'بونص' && 
                         editTransactionFormData.paymentMethodId;
    
    const response = await fetch(`${config.API_BASE_URL}/api/employees/transactions/${editTransactionFormData.transactionId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...editTransactionFormData,
        updatedBy: user.Username,
        needsBankSync: needsBankSync
      })
    });

    if (response.ok) {
      const result = await response.json();
      
      fetchAllTransactions();
      fetchMonthlyStatus();
      fetchStatistics();
      fetchOverduePayments();
      
      // تحديث بيانات الموظف إذا كان محدد
      if (selectedEmployee) {
        fetchTransactions(selectedEmployee.EmployeeId);
        if (activeTab === 'employee-history') {
          fetchEmployeeHistory(selectedEmployee.EmployeeId);
        }
      }
      
      resetEditTransactionForm();
      alert(result.message || 'تم تحديث المعاملة بنجاح');
    } else {
      const error = await response.json();
      alert('خطأ في تحديث المعاملة: ' + (error.error || 'خطأ غير معروف'));
    }
  } catch (error) {
    console.error('خطأ في تحديث المعاملة:', error);
    alert('خطأ في تحديث المعاملة');
  }
};

const handleDeleteTransactionFromAll = async (transactionId, transactionType) => {
  let confirmMessage = 'هل أنت متأكد من حذف هذه المعاملة؟';

  if (transactionType === 'راتب') {
    confirmMessage = 'هل أنت متأكد من حذف معاملة الراتب؟\n\n⚠️ سيتم إرجاع جميع الخصومات وفك ربط البونصات المرتبطة.';
  } else if (transactionType === 'سلفة') {
    confirmMessage = 'هل تريد حذف هذه السلفة؟\n\nملاحظة: الحذف مسموح فقط إذا لم تُسجَّل عليها أي أقساط/مدفوعات.';
  } else if (transactionType === 'دفع قسط') {
    confirmMessage = 'هل أنت متأكد من حذف دفع هذا القسط؟\n\nسيتم إرجاع المبلغ للسلفة وتصبح مستحقة مرة أخرى!';
  } else if (transactionType === 'بونص') {
    confirmMessage = 'هل أنت متأكد من حذف هذا البونص؟';
  }

  if (!window.confirm(confirmMessage)) return;

  try {
    // validateStatus يخلي Axios ما يرميش exception على 409 فنقدر نقرأ الرسالة بسهولة
    const res = await axios.delete(
      `${config.API_BASE_URL}/api/employees/transactions/${transactionId}`,
      { validateStatus: () => true, headers: { 'Accept': 'application/json' } }
    );

    if (!res || res.status < 200 || res.status >= 300 || !res.data?.success) {
      const msg = res?.data?.message || res?.data?.error || `تعذّر حذف المعاملة (HTTP ${res?.status})`;
      alert(msg);
      return;
    }

    // ✅ نجاح: حدّث الواجهة
    setAllTransactionsData(prev => {
      const newList = (prev?.transactions || []).filter(t => t.TransactionId !== transactionId);
      return { ...prev, transactions: newList, totalCount: Math.max(0, (prev?.totalCount ?? newList.length) - 1) };
    });

    if (typeof fetchAllTransactions === 'function') await fetchAllTransactions(true);
    if (typeof fetchMonthlyStatus === 'function') await fetchMonthlyStatus();
    if (typeof fetchStatistics === 'function') await fetchStatistics();
    if (typeof fetchOverduePayments === 'function') await fetchOverduePayments();

    if (selectedEmployee) {
      if (typeof fetchTransactions === 'function') await fetchTransactions(selectedEmployee.EmployeeId);
      if (typeof fetchAdvances === 'function') await fetchAdvances(selectedEmployee.EmployeeId);
      if (activeTab === 'employee-history' && typeof fetchEmployeeHistory === 'function') {
        await fetchEmployeeHistory(selectedEmployee.EmployeeId);
      }
    }

    if (transactionType === 'راتب') {
      alert('✅ تم حذف الراتب وإرجاع الخصومات وفك ربط البونصات');
    } else if (transactionType === 'سلفة') {
      alert('✅ تم حذف السلفة (لا توجد أقساط/مدفوعات)');
    } else if (transactionType === 'دفع قسط') {
      alert('✅ تم إلغاء دفع القسط وإرجاع المبلغ للسلفة');
    } else if (transactionType === 'بونص') {
      alert('✅ تم حذف البونص');
    } else {
      alert('✅ تم حذف المعاملة بنجاح');
    }
  } catch (error) {
    // لو axios رمى exception لأي سبب تاني (نت أو CORS...)
    const msg = error?.response?.data?.message || error?.response?.data?.error || error?.message || 'خطأ في حذف المعاملة';
    console.error('خطأ في حذف المعاملة:', error);
    alert(msg);
  }
};







// إعادة تعيين نموذج التعديل
const resetEditTransactionForm = () => {
  setEditTransactionFormData({
    transactionId: null,
    employeeId: null,
    transactionType: 'بونص', // تغيير القيمة الافتراضية
    amount: '',
    description: '',
    transactionDate: new Date().toISOString().split('T')[0],
    salaryMonth: new Date().getMonth() + 1,
    salaryYear: new Date().getFullYear(),
    paymentMethodId: null,
    paymentMethodType: null,
    bonusType: null // لا نختار قيمة افتراضية
  });
  setEditingTransaction(null);
  setShowEditTransactionForm(false);
};

// فلترة المعاملات
const filteredTransactions = useMemo(() => {
  return allTransactionsData.transactions.filter(transaction => {
    const matchesType = transactionFilter === 'الكل' || transaction.TransactionType === transactionFilter;
    const matchesEmployee = employeeFilter === 'الكل' || transaction.EmployeeId.toString() === employeeFilter;
    const matchesDate = !dateFilter || 
                       new Date(transaction.TransactionDate).toISOString().split('T')[0] === dateFilter;
    
    return matchesType && matchesEmployee && matchesDate;
  });
}, [allTransactionsData.transactions, transactionFilter, employeeFilter, dateFilter]);




  const handleInstallmentPayment = async (e) => {
    e.preventDefault();
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      
      const paymentData = {
        amount: installmentFormData.amount,
        description: installmentFormData.description,
        paymentDate: installmentFormData.paymentDate,
        paidBy: user.Username,
        paymentMethodId: installmentFormData.paymentMethodId || null,
        paymentMethodType: installmentFormData.paymentMethodType || null
      };
      
      console.log('💰 بيانات دفع القسط:', paymentData);
      
      const response = await fetch(`${config.API_BASE_URL}/api/employees/advances/${installmentFormData.advanceId}/pay`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(paymentData)
      });

      if (response.ok) {
        const result = await response.json();
        console.log('✅ نتيجة دفع القسط:', result);
        
        await fetchAdvances(selectedEmployee.EmployeeId);
        await fetchTransactions(selectedEmployee.EmployeeId); // تحديث المعاملات
        await fetchMonthlyStatus();
        await fetchStatistics();
        await fetchOverduePayments();
        
        if (activeTab === 'all-transactions') {
          await fetchAllTransactions();
        }
        
        resetInstallmentForm();
        alert(result.message || 'تم دفع القسط بنجاح');
      } else {
        const error = await response.json();
        console.error('خطأ في دفع القسط:', error);
        alert('خطأ في دفع القسط: ' + (error.error || 'خطأ غير معروف'));
      }
    } catch (error) {
      console.error('خطأ في دفع القسط:', error);
      alert('خطأ في دفع القسط');
    }
  };

  // دالة الراتب الذكي مع التاريخ
  const handleSmartSalaryPayment = async (amount, description, selectedMonth, selectedYear, paymentDate) => {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      await fetch(`${config.API_BASE_URL}/api/employees/${smartSalaryData.employeeId}/transactions`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          transactionType: 'راتب',
          amount: amount,
          description: description,
          salaryMonth: selectedMonth,
          salaryYear: selectedYear,
          transactionDate: paymentDate,
          createdBy: user.Username
        })
      });
      
      if (selectedEmployee && selectedEmployee.EmployeeId === smartSalaryData.employeeId) {
        fetchTransactions(selectedEmployee.EmployeeId);
        if (activeTab === 'employee-history') {
          fetchEmployeeHistory(selectedEmployee.EmployeeId);
        }
      }
      
      fetchMonthlyStatus();
      fetchStatistics();
      fetchOverduePayments();
      setShowSmartSalaryForm(false);
    } catch (error) {
      console.error('خطأ في دفع الراتب:', error);
    }
  };

  // دالة حذف المعاملة
  const handleDeleteTransaction = async (transactionId) => {
    if (!window.confirm('هل أنت متأكد من حذف هذه المعاملة؟')) return;
  
    try {
      const res = await axios.delete(
        `${config.API_BASE_URL}/api/employees/transactions/${transactionId}`,
        { validateStatus: () => true, headers: { Accept: 'application/json' } }
      );
  
      if (!res || res.status < 200 || res.status >= 300 || res.data?.success === false) {
        const msg = res?.data?.message || res?.data?.error || `تعذّر حذف المعاملة (HTTP ${res?.status})`;
        alert(msg); // هنا هتظهر رسالة مثل: "لا يمكن حذف هذا البونص لأنه تم تضمينه في راتب رقم ... "
        return;
      }
  
      // نجاح الحذف → حدّث الواجهة
      await fetchTransactions(selectedEmployee.EmployeeId);
      await fetchMonthlyStatus();
      await fetchStatistics();
      await fetchOverduePayments();
      if (activeTab === 'employee-history') {
        await fetchEmployeeHistory(selectedEmployee.EmployeeId);
      }
  
      alert('✅ تم حذف المعاملة بنجاح');
    } catch (error) {
      alert('خطأ في حذف المعاملة: ' + (error?.message || 'خطأ غير معروف'));
    }
  };

  // فتح النماذج المحدثة
  const openAdvanceForm = (employee) => {
    setAdvanceFormData({
      ...advanceFormData,
      employeeId: employee.EmployeeId,
      employeeName: employee.EmployeeName,
      transactionDate: new Date().toISOString().split('T')[0]
    });
    setShowAdvanceForm(true);
  };

  const openTransactionForm = (employee, transactionType) => {
    setSelectedEmployee(employee);
    setTransactionFormData({
      ...transactionFormData,
      transactionType: transactionType,
      transactionDate: new Date().toISOString().split('T')[0]
    });
    setShowTransactionForm(true);
  };

const openEditAdvanceForm = (advance) => {
  setEditAdvanceFormData({
    advanceId: advance.AdvanceId,
    amount: advance.OriginalAmount,
    paidAmount: advance.PaidAmount, // إضافة المبلغ المدفوع
    remainingAmount: advance.RemainingAmount, // إضافة المبلغ المتبقي
    description: advance.Description,
    installmentAmount: advance.MonthlyInstallment || '',
    numberOfInstallments: advance.NumberOfInstallments || '',
    startDeductionMonth: advance.StartDeductionMonth || new Date().getMonth() + 1,
    startDeductionYear: advance.StartDeductionYear || new Date().getFullYear(),
    isInstallment: advance.IsInstallment
  });
  setShowEditAdvanceForm(true);
};

  const openInstallmentForm = (advance) => {
    setInstallmentFormData({
      advanceId: advance.AdvanceId,
      amount: '',
      description: `دفع قسط من سلفة ${advance.Description}`,
      paymentDate: new Date().toISOString().split('T')[0]
    });
    setShowInstallmentForm(true);
  };

 // دالة جلب الخصومات المعلقة
const fetchPendingDeductions = async (employeeId) => {
  try {
    const response = await fetch(`${config.API_BASE_URL}/api/employees/${employeeId}/pending-deductions`);
    if (response.ok) {
      const data = await response.json();
      setPendingDeductions(data);
    }
  } catch (error) {
    console.error('خطأ في جلب الخصومات المعلقة:', error);
  }
};

const paymentSalaryWithDeductions = async (employeeId, salaryData) => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    
    console.log('بيانات الراتب المرسلة:', salaryData); // للتشخيص
    
    const response = await fetch(`${config.API_BASE_URL}/api/employees/${employeeId}/pay-salary-with-deductions`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...salaryData,
        createdBy: user.Username
      })
    });
    
    if (response.ok) {
      const result = await response.json();
      console.log('نتيجة دفع الراتب:', result); // للتشخيص
      alert(result.message);
      
      // تحديث البيانات
      fetchMonthlyStatus();
      fetchStatistics();
      fetchOverduePayments();
      
      if (selectedEmployee) {
        fetchTransactions(selectedEmployee.EmployeeId);
        fetchPendingDeductions && fetchPendingDeductions(selectedEmployee.EmployeeId);
      }
      
      // تحديث صفحة البنوك إذا كانت مفتوحة
      if (window.location.pathname.includes('banks')) {
        window.location.reload();
      }
      
    } else {
      const error = await response.json();
      console.error('خطأ في دفع الراتب:', error); // للتشخيص
      alert('خطأ: ' + error.error);
    }
  } catch (error) {
    console.error('خطأ في دفع الراتب:', error);
    alert('خطأ في دفع الراتب');
  }
};

// تحديث openSmartSalaryForm لجلب الخصومات المعلقة
const openSmartSalaryForm = async (employee) => {
  const month = statusMonth;
  const year = statusYear;
  
  try {
    const [salaryResponse, deductionsResponse] = await Promise.all([
      fetch(`${config.API_BASE_URL}/api/employees/${employee.EmployeeId}/salary-summary/${month}/${year}`),
      fetch(`${config.API_BASE_URL}/api/employees/${employee.EmployeeId}/pending-deductions`)
    ]);
    
    const salarySummary = await salaryResponse.json();
    const pendingDeductionsData = await deductionsResponse.json();
    
    setSmartSalaryData({
      employeeId: employee.EmployeeId,
      employeeName: employee.EmployeeName,
      salarySummary: salarySummary,
      pendingDeductions: pendingDeductionsData,
      suggestedAmount: Math.max(0, salarySummary?.remainingSalary || 0),
      maxAmount: Math.max(0, salarySummary?.remainingSalary || 0)
    });
    setShowSmartSalaryForm(true);
  } catch (error) {
    console.error('خطأ في جلب ملخص الراتب:', error);
  }
};
  const openEmployeeHistory = (employee) => {
    setSelectedEmployee(employee);
    fetchEmployeeHistory(employee.EmployeeId);
    setActiveTab('employee-history');
  };

const resetEmployeeForm = () => {
  setEmployeeFormData({
    employeeName: '',
    position: '',
    basicSalary: '',
    phone: '',
    email: '',
    hireDate: '',
    notes: '',
    profileImage: null
  });
  setImagePreview(null);
  setEditingId(null);
  setIsSubmitting(false); // ← أضف هذا السطر المهم
  setShowEmployeeForm(false);
};

const resetTransactionForm = () => {
  setTransactionFormData({
    transactionType: 'بونص', // تغيير القيمة الافتراضية من 'راتب' إلى 'بونص'
    amount: '',
    description: '',
    transactionDate: new Date().toISOString().split('T')[0],
    salaryMonth: new Date().getMonth() + 1,
    salaryYear: new Date().getFullYear(),
    employeeId: null,
    paymentMethodId: null,
    paymentMethodType: null,
    bonusType: 'with_salary' // القيمة الافتراضية
  });
  if (activeTab === 'all-transactions') {
    setSelectedEmployee(null);
  }
  setShowTransactionForm(false);
};

  const resetAdvanceForm = () => {
    setAdvanceFormData({
      employeeId: null,
      amount: '',
      description: '',
      installmentAmount: '',
      numberOfInstallments: '',
      startDeductionMonth: new Date().getMonth() + 1,
      startDeductionYear: new Date().getFullYear(),
      isInstallment: false,
      transactionDate: new Date().toISOString().split('T')[0],
      paymentMethodId: null,
      paymentMethodType: null
    });
    setShowAdvanceForm(false);
  };

const resetEditAdvanceForm = () => {
  setEditAdvanceFormData({
    advanceId: null,
    amount: '',
    paidAmount: 0,
    remainingAmount: 0,
    description: '',
    installmentAmount: '',
    numberOfInstallments: '',
    startDeductionMonth: new Date().getMonth() + 1,
    startDeductionYear: new Date().getFullYear(),
    isInstallment: false
  });
  setShowEditAdvanceForm(false);
};

 const resetInstallmentForm = () => {
    setInstallmentFormData({
      advanceId: null,
      amount: '',
      description: '',
      paymentDate: new Date().toISOString().split('T')[0],
      paymentMethodId: null,
      paymentMethodType: null
    });
    setShowInstallmentForm(false);
  };

  // دوال مساعدة
  const handleEdit = (employee) => {
    setEmployeeFormData({
      employeeName: employee.EmployeeName,
      position: employee.Position,
      basicSalary: employee.BasicSalary,
      phone: employee.Phone || '',
      email: employee.Email || '',
      hireDate: employee.HireDate ? employee.HireDate.split('T')[0] : '',
      notes: employee.Notes || '',
      profileImage: null,
      currentImageBase64: employee.ProfileImageBase64 // إضافة هذا السطر
    });
    
    if (employee.ProfileImageBase64) {
      setImagePreview(employee.ProfileImageBase64);
    } else {
      setImagePreview(null);
    }
    
    setEditingId(employee.EmployeeId);
    setShowEmployeeForm(true);
  };

  const handleDelete = async (employeeId) => {
    if (window.confirm('هل أنت متأكد من حذف هذا الموظف؟')) {
      try {
        await fetch(`${config.API_BASE_URL}/api/employees/${employeeId}`, {
          method: 'DELETE'
        });
        fetchEmployees();
        fetchMonthlyStatus();
        fetchStatistics();
        fetchOverduePayments();
      } catch (error) {
        console.error('خطأ في حذف الموظف:', error);
      }
    }
  };

  const openTransactions = (employee) => {
    setSelectedEmployee(employee);
    fetchTransactions(employee.EmployeeId);
    fetchAdvances(employee.EmployeeId);
    setActiveTab('transactions');
  };

  // دالة تحديث حالة الشهر
  const handleMonthlyStatusChange = () => {
    fetchMonthlyStatus(statusMonth, statusYear);
    fetchStatistics();
  };

  const filteredEmployees = (employees || []).filter(emp =>
    emp.EmployeeName?.toLowerCase().includes(search.toLowerCase()) ||
    emp.Position?.toLowerCase().includes(search.toLowerCase())
  );

  const formatCurrency = useCallback((amount) => {
    return new Intl.NumberFormat('ar-EG', {
      style: 'currency',
      currency: 'EGP'
    }).format(amount || 0);
  }, []);

  const formatDate = useCallback((dateString) => {
    return new Date(dateString).toLocaleDateString('ar-EG');
  }, []);
  const getStatusColor = (status) => {
    switch(status) {
      case 'مكتمل': return 'bg-green-100 text-green-800';
      case 'غير مكتمل': return 'bg-orange-100 text-orange-800';
      case 'متأخر': return 'bg-red-100 text-red-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const getMonthName = useCallback((monthNumber) => {
    return new Date(0, monthNumber - 1).toLocaleDateString('ar-EG', { month: 'long' });
  }, []);

  return (
    <div className="employee-management-page container mx-auto p-6 text-right bg-gray-50 min-h-screen" dir="rtl">

      <style>{`
        @media (min-width: 769px) {
          .employee-mobile-card-list { display: none !important; }
        }
        @media (max-width: 768px) {
          html, body, #root { overflow-x: hidden !important; }
          .employee-management-page {
            width: 100% !important;
            max-width: 100% !important;
            padding: 10px !important;
            background: rgb(var(--bg-slate-50, 248 250 252)) !important;
            overflow-x: hidden !important;
          }
          .employee-management-page * { box-sizing: border-box; }
          .employee-management-page > .grid {
            grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
            gap: 10px !important;
            margin-bottom: 12px !important;
          }
          .employee-management-page .bg-gradient-to-br {
            border-radius: 18px !important;
            padding: 14px !important;
            min-height: 104px !important;
          }
          .employee-management-page .bg-gradient-to-br p.text-3xl,
          .employee-management-page .bg-gradient-to-br p.text-2xl {
            font-size: 20px !important;
            line-height: 1.25 !important;
          }
          .employee-management-page .rounded-lg.shadow-lg.p-6 {
            padding: 12px !important;
            border-radius: 20px !important;
            margin-bottom: 12px !important;
          }
          .employee-management-page h1 {
            font-size: 24px !important;
            line-height: 1.35 !important;
            gap: 8px !important;
          }
          .employee-management-page h2 {
            font-size: 20px !important;
            line-height: 1.35 !important;
          }
          .employee-management-page h3 {
            font-size: 18px !important;
            line-height: 1.35 !important;
          }
          .employee-management-page input,
          .employee-management-page select,
          .employee-management-page textarea {
            width: 100% !important;
            min-height: 48px !important;
            font-size: 16px !important;
            border-radius: 14px !important;
          }
          .employee-management-page button {
            min-height: 44px;
            border-radius: 14px !important;
            white-space: normal !important;
          }
          .employee-management-page .employee-mobile-tabs {
            display: flex !important;
            overflow-x: auto !important;
            gap: 8px !important;
            padding: 2px 0 10px !important;
            border-bottom: 0 !important;
            scroll-snap-type: x proximity;
            -webkit-overflow-scrolling: touch;
          }
          .employee-management-page .employee-mobile-tabs button {
            flex: 0 0 auto !important;
            min-width: 132px !important;
            padding: 12px 14px !important;
            border-radius: 16px !important;
            scroll-snap-align: start;
            box-shadow: 0 6px 18px rgba(15, 23, 42, 0.08);
          }
          .employee-management-page .employee-mobile-tabs::-webkit-scrollbar { display: none; }
          .employee-management-page .employee-desktop-table { display: none !important; }
          .employee-management-page .employee-mobile-card-list { display: block !important; }
          .employee-management-page .grid.grid-cols-1.md\\:grid-cols-2.lg\\:grid-cols-3,
          .employee-management-page .grid.grid-cols-1.md\\:grid-cols-2,
          .employee-management-page .grid.grid-cols-1.md\\:grid-cols-4,
          .employee-management-page .grid.grid-cols-1.md\\:grid-cols-3,
          .employee-management-page .grid.grid-cols-1.md\\:grid-cols-5 {
            grid-template-columns: 1fr !important;
            gap: 12px !important;
          }
          .employee-management-page .grid.grid-cols-2.gap-4,
          .employee-management-page .grid.grid-cols-2.md\\:grid-cols-4 {
            grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
            gap: 10px !important;
          }
          .employee-management-page .flex.justify-between.items-center,
          .employee-management-page .flex.justify-between.items-start {
            gap: 10px !important;
            flex-wrap: wrap !important;
          }
          .employee-management-page .relative.w-80 { width: 100% !important; }
          .employee-management-page .flex.gap-4,
          .employee-management-page .flex.gap-2 {
            flex-wrap: wrap !important;
          }
          .employee-management-page .flex.gap-4 > *,
          .employee-management-page .flex.gap-2 > * {
            min-width: 0;
          }
          .employee-mobile-modal {
            align-items: stretch !important;
            justify-content: center !important;
            padding: 0 !important;
            z-index: 9999 !important;
          }
          .employee-mobile-modal > .bg-white {
            width: 100% !important;
            max-width: none !important;
            height: 100dvh !important;
            max-height: 100dvh !important;
            margin: 0 !important;
            border-radius: 0 !important;
            padding: 14px !important;
            padding-bottom: 116px !important;
            overflow-y: auto !important;
          }
          .employee-mobile-modal > .bg-white > .flex.justify-between.items-center:first-child {
            position: sticky;
            top: 0;
            z-index: 20;
            background: rgb(var(--bg-white, 255 255 255));
            padding: 10px 0 12px;
            margin-bottom: 12px !important;
            border-bottom: 1px solid rgb(var(--border-gray-200, 229 231 235));
          }
          .employee-mobile-modal form .grid.grid-cols-2,
          .employee-mobile-modal form .grid.grid-cols-1.md\\:grid-cols-2,
          .employee-mobile-modal form .grid.grid-cols-1.md\\:grid-cols-3 {
            grid-template-columns: 1fr !important;
          }
          .employee-mobile-modal form > .flex.justify-end,
          .employee-mobile-modal form .flex.justify-end.gap-4 {
            position: sticky;
            bottom: -14px;
            background: rgb(var(--bg-white, 255 255 255));
            padding: 12px 0 14px;
            margin-top: 14px;
            display: flex !important;
            flex-direction: column !important;
            gap: 10px !important;
            box-shadow: 0 -12px 24px rgba(15, 23, 42, 0.08);
          }
          .employee-mobile-modal form > .flex.justify-end button,
          .employee-mobile-modal form .flex.justify-end.gap-4 button {
            width: 100% !important;
            justify-content: center !important;
          }
          .employee-mobile-card {
            border-radius: 18px;
            border: 1px solid rgb(var(--border-gray-200, 229 231 235));
            background: rgb(var(--bg-white, 255 255 255));
            box-shadow: 0 10px 26px rgba(15, 23, 42, 0.07);
            padding: 14px;
          }
          .employee-mobile-kv {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 8px;
          }
          .employee-mobile-kv > div {
            background: rgb(var(--bg-slate-50, 248 250 252));
            border-radius: 14px;
            padding: 10px;
            min-width: 0;
          }
          .employee-mobile-label { color: rgb(var(--text-slate-400, 148 163 184)); font-size: 12px; margin-bottom: 4px; }
          .employee-mobile-value { color: rgb(var(--text-slate-900, 15 23 42)); font-weight: 700; font-size: 14px; word-break: break-word; }
        }
      `}</style>
      
      {/* Statistics Dashboard */}
      {statistics && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl shadow-lg p-6 text-white">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-blue-100 text-sm font-medium">إجمالي الموظفين</p>
                <p className="text-3xl font-bold">{statistics.TotalEmployees}</p>
              </div>
              <div className="bg-blue-400 bg-opacity-30 rounded-full p-3">
                <Users size={24} />
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-xl shadow-lg p-6 text-white">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-green-100 text-sm font-medium">إجمالي الرواتب المدفوعة</p>
                <p className="text-2xl font-bold">{formatCurrency(statistics.TotalPaidSalaries)}</p>
              </div>
              <div className="bg-green-400 bg-opacity-30 rounded-full p-3">
                <Wallet size={24} />
              </div>
            </div>
          </div>

          





          <div className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl shadow-lg p-6 text-white">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-orange-100 text-sm font-medium">الدفعات المكتملة</p>
                <p className="text-3xl font-bold">{statistics.CompletedPayments}</p>
                <p className="text-xs text-orange-100">من أصل {statistics.TotalEmployees}</p>
              </div>
              <div className="bg-orange-400 bg-opacity-30 rounded-full p-3">
                <CheckCircle size={24} />
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-red-500 to-red-600 rounded-xl shadow-lg p-6 text-white">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-red-100 text-sm font-medium">رواتب متأخرة</p>
                <p className="text-3xl font-bold">{overduePayments.length}</p>
                <p className="text-xs text-red-100">تحتاج متابعة عاجلة</p>
              </div>
              <div className="bg-red-400 bg-opacity-30 rounded-full p-3">
                <AlertCircle size={24} />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold text-gray-800 flex items-center gap-3">
            <User className="text-blue-600" size={32} />
            إدارة حسابات الموظفين
          </h1>
          <button 
            onClick={() => navigate('/')}
            className="bg-gray-500 hover:bg-gray-600 text-white px-6 py-2 rounded-lg transition-colors"
          >
            العودة للرئيسية
          </button>
        </div>
        
{/* Navigation Tabs */}
<div className="employee-mobile-tabs flex space-x-2 space-x-reverse border-b">
  <button
    className={`px-6 py-3 font-medium rounded-t-lg transition-colors ${
      activeTab === 'employees' 
        ? 'bg-blue-600 text-white border-b-2 border-blue-600' 
        : 'text-gray-600 hover:text-blue-600'
    }`}
    onClick={() => setActiveTab('employees')}
  >
    إدارة الموظفين
  </button>
  <button
    className={`px-6 py-3 font-medium rounded-t-lg transition-colors ${
      activeTab === 'transactions' 
        ? 'bg-blue-600 text-white border-b-2 border-blue-600' 
        : 'text-gray-600 hover:text-blue-600'
    }`}
    onClick={() => setActiveTab('transactions')}
  >
    المعاملات والسلف
  </button>
  <button
    className={`px-6 py-3 font-medium rounded-t-lg transition-colors ${
      activeTab === 'employee-history' 
        ? 'bg-indigo-600 text-white border-b-2 border-indigo-600' 
        : 'text-gray-600 hover:text-indigo-600'
    }`}
    onClick={() => setActiveTab('employee-history')}
  >
    سجل موظف
  </button>
  <button
    className={`px-6 py-3 font-medium rounded-t-lg transition-colors ${
      activeTab === 'all-transactions' 
        ? 'bg-purple-600 text-white border-b-2 border-purple-600' 
        : 'text-gray-600 hover:text-purple-600'
    }`}
    onClick={() => {
      setActiveTab('all-transactions');
      fetchAllTransactions(true);
    }}
  >
    سجل المعاملات الشامل
  </button>
  <button
    className={`px-6 py-3 font-medium rounded-t-lg transition-colors ${
      activeTab === 'monthly-status' 
        ? 'bg-blue-600 text-white border-b-2 border-blue-600' 
        : 'text-gray-600 hover:text-blue-600'
    }`}
    onClick={() => {
      setActiveTab('monthly-status');
      fetchMonthlyStatus();
    }}
  >
    الحالة الشهرية
  </button>
  <button
    className={`px-6 py-3 font-medium rounded-t-lg transition-colors ${
      activeTab === 'overdue' 
        ? 'bg-red-600 text-white border-b-2 border-red-600' 
        : 'text-gray-600 hover:text-red-600'
    }`}
    onClick={() => {
      setActiveTab('overdue');
      fetchOverduePayments();
    }}
  >
    الرواتب المتأخرة
  </button>
  <button
    className={`px-6 py-3 font-medium rounded-t-lg transition-colors ${
      activeTab === 'reports' 
        ? 'bg-blue-600 text-white border-b-2 border-blue-600' 
        : 'text-gray-600 hover:text-blue-600'
    }`}
    onClick={() => {
      setActiveTab('reports');
      fetchSalaryReport();
    }}
  >
    تقارير الرواتب
  </button>
</div>
      </div>

{/* Monthly Status Tab - محسن مع اختيار الشهر */}
      {activeTab === 'monthly-status' && (
        <div className="bg-white rounded-lg shadow-lg p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-3">
              <TrendingUp className="text-blue-600" size={28} />
              حالة الرواتب الشهرية
            </h2>
            <div className="flex gap-4 items-center">
              <select
                value={statusMonth}
                onChange={(e) => setStatusMonth(parseInt(e.target.value))}
                className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {[...Array(12)].map((_, i) => (
                  <option key={i} value={i + 1}>
                    {getMonthName(i + 1)}
                  </option>
                ))}
              </select>
              <select
                value={statusYear}
                onChange={(e) => setStatusYear(parseInt(e.target.value))}
                className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {[...Array(5)].map((_, i) => (
                  <option key={i} value={new Date().getFullYear() - i}>
                    {new Date().getFullYear() - i}
                  </option>
                ))}
              </select>
              <button
                onClick={handleMonthlyStatusChange}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg transition-colors"
              >
                تحديث
              </button>
            </div>
          </div>

          {/* ملخص عام */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
            <div className="bg-green-50 p-4 rounded-lg border border-green-200">
              <div className="flex items-center gap-2 mb-2">
                <CheckCircle className="text-green-600" size={20} />
                <span className="font-medium text-green-800">مكتمل الراتب</span>
              </div>
              <div className="text-2xl font-bold text-green-600">
                {monthlyStatus.filter(emp => emp.PaymentStatus === 'مكتمل').length}
              </div>
            </div>
            
            <div className="bg-orange-50 p-4 rounded-lg border border-orange-200">
              <div className="flex items-center gap-2 mb-2">
                <Clock className="text-orange-600" size={20} />
                <span className="font-medium text-orange-800">غير مكتمل</span>
              </div>
              <div className="text-2xl font-bold text-orange-600">
                {monthlyStatus.filter(emp => emp.PaymentStatus === 'غير مكتمل').length}
              </div>
            </div>
            
            <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
              <div className="flex items-center gap-2 mb-2">
                <DollarSign className="text-blue-600" size={20} />
                <span className="font-medium text-blue-800">إجمالي المدفوع</span>
              </div>
              <div className="text-lg font-bold text-blue-600">
                {formatCurrency(monthlyStatus.reduce((sum, emp) => sum + emp.PaidSalary, 0))}
              </div>
            </div>
            
            <div className="bg-red-50 p-4 rounded-lg border border-red-200">
              <div className="flex items-center gap-2 mb-2">
                <AlertCircle className="text-red-600" size={20} />
                <span className="font-medium text-red-800">إجمالي المتبقي</span>
              </div>
              <div className="text-lg font-bold text-red-600">
                {formatCurrency(monthlyStatus.reduce((sum, emp) => sum + (emp.RemainingSalary > 0 ? emp.RemainingSalary : 0), 0))}
              </div>
            </div>
          </div>

          {/* قائمة الموظفين */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {monthlyStatus.map((employee) => (
              <div key={employee.EmployeeId} className={`p-4 rounded-lg border-2 ${
                employee.PaymentStatus === 'مكتمل' 
                  ? 'border-green-500 bg-green-50' 
                  : 'border-orange-500 bg-orange-50'
              }`}>
                <div className="flex justify-between items-center mb-3">
                  <h3 className="font-bold text-lg">{employee.EmployeeName}</h3>
                  <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                    employee.PaymentStatus === 'مكتمل'
                      ? 'bg-green-600 text-white'
                      : 'bg-orange-600 text-white'
                  }`}>
                    {employee.PaymentStatus}
                  </span>
                </div>
                
                <div className="space-y-2 text-sm mb-4">
                  <div className="flex justify-between">
                    <span>الراتب الأساسي:</span>
                    <span className="font-medium">{formatCurrency(employee.BasicSalary)}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>المدفوع:</span>
                    <span className="font-medium text-green-600">{formatCurrency(employee.PaidSalary)}</span>
                  </div>
                  
                  {employee.TotalAdvance > 0 && (
                    <div className="flex justify-between">
                      <span>السلف:</span>
                      <span className="font-medium text-orange-600">{formatCurrency(employee.TotalAdvance)}</span>
                    </div>
                  )}
                  
                  {employee.TotalDeduction > 0 && (
                    <div className="flex justify-between">
                      <span>الخصومات:</span>
                      <span className="font-medium text-red-600">{formatCurrency(employee.TotalDeduction)}</span>
                    </div>
                  )}
                  
                  {employee.TotalBonus > 0 && (
                    <div className="flex justify-between">
                      <span>البونصات:</span>
                      <span className="font-medium text-green-600">{formatCurrency(employee.TotalBonus)}</span>
                    </div>
                  )}
                  
                  <div className="flex justify-between border-t pt-2">
                    <span className="font-bold">المتبقي:</span>
                    <span className={`font-bold ${employee.RemainingSalary > 0 ? 'text-blue-600' : 'text-gray-600'}`}>
                      {formatCurrency(employee.RemainingSalary)}
                    </span>
                  </div>
                </div>

                <div className="flex gap-2">
                  {employee.RemainingSalary > 0 && canDo('دفع راتب') && (
                    <button
                      onClick={() => openSmartSalaryForm(employee)}
                      className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded text-sm transition-colors"
                    >
                      دفع راتب                     </button>
                  )}
                  <button
                    onClick={() => openTransactions(employee)}
                    className="bg-purple-600 hover:bg-purple-700 text-white px-3 py-2 rounded text-sm transition-colors"
                  >
                    التفاصيل
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

{/* Overdue Payments Tab - محسن */}
      {activeTab === 'overdue' && (
        <div className="bg-white rounded-lg shadow-lg p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-3">
              <AlertCircle className="text-red-600" size={28} />
              الرواتب المتأخرة
            </h2>
            <button
              onClick={fetchOverduePayments}
              className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg transition-colors"
            >
              تحديث
            </button>
          </div>

       {(overduePayments || []).length === 0 ? (
  <div className="text-center py-20">
    <CheckCircle className="mx-auto text-green-400 mb-4" size={64} />
    <p className="text-xl text-green-600">ممتاز! لا توجد رواتب متأخرة</p>
    <p className="text-gray-500 mt-2">جميع الموظفين النشطين قد تم دفع رواتبهم في المواعيد المحددة</p>
  </div>
) : (
  <>
    {/* إحصائيات سريعة */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
      <div className="bg-red-50 p-4 rounded-lg border border-red-200">
        <div className="text-sm text-red-600 font-medium">عدد الموظفين المتأخرين</div>
        <div className="text-2xl font-bold text-red-700">
          {new Set((overduePayments || []).map(emp => emp.EmployeeId)).size}
        </div>
      </div>
      
      <div className="bg-orange-50 p-4 rounded-lg border border-orange-200">
        <div className="text-sm text-orange-600 font-medium">إجمالي الشهور المتأخرة</div>
        <div className="text-2xl font-bold text-orange-700">
          {(overduePayments || []).length}
        </div>
      </div>
      
      <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
        <div className="text-sm text-blue-600 font-medium">إجمالي المبلغ المتأخر</div>
        <div className="text-lg font-bold text-blue-700">
          {formatCurrency((overduePayments || []).reduce((sum, emp) => sum + emp.RemainingSalary, 0))}
        </div>
      </div>
    </div>

              {/* قائمة الرواتب المتأخرة */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {overduePayments.map((employee) => (
                  <div key={`${employee.EmployeeId}-${employee.Month}-${employee.Year}`} className="p-4 rounded-lg border-2 border-red-500 bg-red-50">
                    <div className="flex justify-between items-center mb-3">
                      <h3 className="font-bold text-lg">{employee.EmployeeName}</h3>
                      <span className="px-3 py-1 rounded-full text-sm font-medium bg-red-600 text-white">
                        متأخر
                      </span>
                    </div>
                    
                    <div className="space-y-2 text-sm mb-4">
                      <div className="flex justify-between">
                        <span>الشهر:</span>
                        <span className="font-medium">{getMonthName(employee.Month)} {employee.Year}</span>
                      </div>
                      
                      <div className="flex justify-between">
                        <span>تاريخ التوظيف:</span>
                        <span className="font-medium text-blue-600">{formatDate(employee.HireDate)}</span>
                      </div>
                      
                      <div className="flex justify-between">
                        <span>أشهر الخدمة:</span>
                        <span className="font-medium">{employee.MonthsSinceHire} شهر</span>
                      </div>
                      
                      <div className="border-t pt-2">
                        <div className="flex justify-between">
                          <span>الراتب الأساسي:</span>
                          <span className="font-medium">{formatCurrency(employee.BasicSalary)}</span>
                        </div>
                        <div className="flex justify-between">
                          <span>المدفوع:</span>
                          <span className="font-medium text-green-600">{formatCurrency(employee.PaidSalary)}</span>
                        </div>
                        
                        {employee.TotalBonus > 0 && (
                          <div className="flex justify-between">
                            <span>البونصات:</span>
                            <span className="font-medium text-blue-600">{formatCurrency(employee.TotalBonus)}</span>
                          </div>
                        )}
                        
                        {employee.TotalDeduction > 0 && (
                          <div className="flex justify-between">
                            <span>الخصومات:</span>
                            <span className="font-medium text-orange-600">{formatCurrency(employee.TotalDeduction)}</span>
                          </div>
                        )}
                        
                        {employee.TotalAdvanceDeductions > 0 && (
                          <div className="flex justify-between">
                            <span>خصم السلف:</span>
                            <span className="font-medium text-purple-600">{formatCurrency(employee.TotalAdvanceDeductions)}</span>
                          </div>
                        )}
                        
                        <div className="flex justify-between border-t pt-2">
                          <span className="font-bold">المتبقي:</span>
                          <span className="font-bold text-red-600">{formatCurrency(employee.RemainingSalary)}</span>
                        </div>
                      </div>
                      
                      <div className="flex justify-between border-t pt-2">
                        <span>عدد الأيام المتأخرة:</span>
                        <span className="font-medium text-red-600">{employee.DaysOverdue} يوم</span>
                      </div>
                    </div>

                    {canDo('دفع الراتب المتأخر') && (
                    <button
                      onClick={async () => {
                        const response = await fetch(`${config.API_BASE_URL}/api/employees/${employee.EmployeeId}/salary-summary/${employee.Month}/${employee.Year}`);
                        const salarySummary = await response.json();
                        
                        setSmartSalaryData({
                          employeeId: employee.EmployeeId,
                          employeeName: employee.EmployeeName,
                          salarySummary: salarySummary,
                          suggestedAmount: Math.max(0, salarySummary?.remainingSalary || 0),
                          maxAmount: Math.max(0, salarySummary?.remainingSalary || 0),
                          selectedMonth: employee.Month,
                          selectedYear: employee.Year
                        });
                        setShowSmartSalaryForm(true);
                      }}
                      className="w-full bg-red-600 hover:bg-red-700 text-white py-2 px-4 rounded text-sm transition-colors"
                    >
                      دفع الراتب المتأخر
                    </button>
                    )}
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      )}

      {/* Transactions and Advances Tab - محسن مع أزرار منفصلة */}
      {activeTab === 'transactions' && (
        <div className="bg-white rounded-lg shadow-lg p-6">
          {selectedEmployee ? (
            <>
              <div className="flex justify-between items-center mb-6">
                <div>
                  <h2 className="text-2xl font-bold text-gray-800">معاملات وسلف الموظف: {selectedEmployee.EmployeeName}</h2>
                  <p className="text-gray-600">المنصب: {selectedEmployee.Position} | الراتب الأساسي: {formatCurrency(selectedEmployee.BasicSalary)}</p>
                </div>
                <div className="flex gap-2">
                  {canDo('بونص وخصم') && (
                  <button 
                    className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
                    onClick={() => openTransactionForm(selectedEmployee, 'بونص')}
                  >
                    <Gift size={20} />
                    بونص
                  </button>
                  )}
                  {canDo('بونص وخصم') && (
                  <button 
                    className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
                    onClick={() => openTransactionForm(selectedEmployee, 'خصم')}
                  >
                    <Minus size={20} />
                    خصم
                  </button>
                  )}
                  {canDo('إضافة سلفة') && (
                  <button 
                    className="bg-orange-600 hover:bg-orange-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
                    onClick={() => openAdvanceForm(selectedEmployee)}
                  >
                    <CreditCard size={20} />
                    إضافة سلفة
                  </button>
                  )}
                </div>
              </div>

              {/* السلف النشطة مع خيارات التعديل والحذف */}
              {advances.length > 0 && (
                <div className="mb-6">
                  <h3 className="text-xl font-bold text-gray-800 mb-4">السلف النشطة</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {advances.map((advance) => (
  <div key={advance.AdvanceId} className={`p-4 rounded-lg border-2 ${
    advance.RemainingAmount > 0 ? 'border-orange-500 bg-orange-50' : 'border-green-500 bg-green-50'
  }`}>
    <div className="flex justify-between items-start">
      <div>
        <h4 className="font-bold">{advance.Description}</h4>
        <div className="flex gap-1">
          <span className={`px-2 py-1 rounded-full text-xs ${
            advance.RemainingAmount > 0 ? 'bg-orange-600 text-white' : 'bg-green-600 text-white'
          }`}>
            {advance.RemainingAmount > 0 ? 'نشط' : 'مسدد'}
          </span>
        </div>
      </div>
    </div>
    
    <div className="space-y-1 text-sm mb-3">
      <div className="flex justify-between">
        <span>المبلغ الأصلي:</span>
        <span className="font-medium">{formatCurrency(advance.OriginalAmount)}</span>
      </div>
      <div className="flex justify-between">
        <span>المدفوع:</span>
        <span className="font-medium text-green-600">{formatCurrency(advance.PaidAmount)}</span>
      </div>
      <div className="flex justify-between">
        <span>المتبقي:</span>
        <span className="font-medium text-orange-600">{formatCurrency(advance.RemainingAmount)}</span>
      </div>
      
      {advance.IsInstallment && advance.RemainingAmount > 0 && (
        <>
          <div className="flex justify-between">
            <span>القسط التالي:</span>
            <span className="font-medium text-blue-600">
              {formatCurrency(Math.min(advance.MonthlyInstallment, advance.RemainingAmount))}
            </span>
          </div>
          <div className="flex justify-between">
            <span>الأقساط المتبقية:</span>
            <span>{Math.ceil(advance.RemainingAmount / advance.MonthlyInstallment)} قسط</span>
          </div>
          <div className="flex justify-between">
            <span>موعد البداية:</span>
            <span>{advance.StartDeductionMonth}/{advance.StartDeductionYear}</span>
          </div>
        </>
      )}
    </div>
    
    <div className="flex gap-2">
      {advance.RemainingAmount > 0 && canDo('إضافة سلفة') && (
        <button
          onClick={() => openInstallmentForm(advance)}
          className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded text-sm transition-colors"
        >
          دفع قسط
        </button>
      )}
      {canDo('تعديل سلفة') && (
      <button
        onClick={() => openEditAdvanceForm(advance)}
        className="bg-yellow-600 hover:bg-yellow-700 text-white px-3 py-2 rounded text-sm transition-colors"
        title="تعديل السلفة"
      >
        <Edit size={16} />
      </button>
      )}
      
    </div>
  </div>
))}
                  </div>
                </div>
              )}

{/* سجل المعاملات المحسن */}
<div>
  <h3 className="text-xl font-bold text-gray-800 mb-4">سجل المعاملات</h3>
  <div className="bg-white rounded-lg shadow overflow-hidden">
    <div className="employee-desktop-table overflow-x-auto">
      <table className="w-full">
        <thead className="bg-gradient-to-r from-blue-600 to-blue-700 text-white">
          <tr>
            <th className="px-4 py-3 text-right text-sm font-semibold">التاريخ</th>
            <th className="px-4 py-3 text-right text-sm font-semibold">النوع</th>
            <th className="px-4 py-3 text-right text-sm font-semibold">المبلغ</th>
            <th className="px-4 py-3 text-right text-sm font-semibold">طريقة الدفع</th>
            <th className="px-4 py-3 text-right text-sm font-semibold">الوصف</th>
            <th className="px-4 py-3 text-right text-sm font-semibold">الشهر/السنة</th>
            <th className="px-4 py-3 text-right text-sm font-semibold">أضيف بواسطة</th>
            <th className="px-4 py-3 text-right text-sm font-semibold">حالة التطبيق</th>
            <th className="px-4 py-3 text-right text-sm font-semibold">الإجراءات</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {transactions.map((transaction, index) => (
            <tr key={transaction.TransactionId} className={`hover:bg-gray-50 transition-colors ${
              index % 2 === 0 ? 'bg-white' : 'bg-gray-25'
            }`}>
              {/* التاريخ */}
              <td className="px-4 py-3">
                <div className="text-sm font-medium text-gray-900">
                  {formatDate(transaction.TransactionDate)}
                </div>
                <div className="text-xs text-gray-500">
                  {new Date(transaction.TransactionDate).toLocaleTimeString('ar-EG', {
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </div>
              </td>

              {/* النوع */}
              <td className="px-4 py-3">
                <div className="flex flex-col gap-1">
                  <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                    transaction.TransactionType === 'راتب' 
                      ? 'bg-green-100 text-green-800'
                      : transaction.TransactionType === 'سلفة'
                      ? 'bg-orange-100 text-orange-800'
                      : transaction.TransactionType === 'بونص'
                      ? 'bg-blue-100 text-blue-800'
                      : transaction.TransactionType === 'دفع قسط'
                      ? 'bg-purple-100 text-purple-800'
                      : 'bg-red-100 text-red-800'
                  }`}>
                    {transaction.TransactionType}
                  </span>
                  {/* نوع البونص */}
                  {transaction.TransactionType === 'بونص' && (
                    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs ${
                      transaction.PaymentMethodId 
                        ? 'bg-green-50 text-green-700 border border-green-200' 
                        : 'bg-yellow-50 text-yellow-700 border border-yellow-200'
                    }`}>
                      {transaction.PaymentMethodId ? '💰 مباشر' : '📅 مع الراتب'}
                    </span>
                  )}
                </div>
              </td>

              {/* المبلغ */}
              <td className="px-4 py-3">
                <div className={`text-sm font-bold ${
                  ['راتب', 'بونص', 'سلفة'].includes(transaction.TransactionType)
                    ? 'text-red-600'
                    : 'text-green-600'
                }`}>
                  {formatCurrency(transaction.Amount)}
                </div>
              </td>

{/* طريقة الدفع مع tooltip */}
<td className="px-4 py-4">
  <div className="text-sm">
    {transaction.PaymentMethodId ? (
      <div 
        className="space-y-1 cursor-help"
        title={`طريقة الدفع: ${transaction.PaymentMethodName}\nرقم الحساب: ${transaction.PaymentMethodAccount}\nالبنك: ${transaction.PaymentMethodBank}`}
      >
        <span className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-50 text-blue-800 border border-blue-200">
          🏦 {transaction.PaymentMethodName || 'بنكي'}
        </span>
        <div className="text-xs text-gray-500 truncate max-w-20">
          {transaction.PaymentMethodAccount}
        </div>
      </div>
    ) : transaction.TransactionType === 'خصم' ? (
      <span className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-gray-50 text-gray-600 border border-gray-200">
        ⏳ معلق
      </span>
    ) : (
      <span className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-green-50 text-green-700 border border-green-200">
        💵 نقدي
      </span>
    )}
  </div>
</td>

              {/* الوصف */}
              <td className="px-4 py-3">
                <div className="text-sm text-gray-900 max-w-xs">
                  <div className="truncate" title={transaction.Description}>
                    {transaction.Description}
                  </div>
                </div>
              </td>

              {/* الشهر/السنة */}
              <td className="px-4 py-3">
                <div className="text-sm text-gray-600">
                  {transaction.SalaryMonth && transaction.SalaryYear 
                    ? `${getMonthName(transaction.SalaryMonth)} ${transaction.SalaryYear}`
                    : '-'
                  }
                </div>
              </td>

              {/* أضيف بواسطة */}
              <td className="px-4 py-3">
                <div className="text-sm text-gray-600">{transaction.CreatedByFullName || transaction.CreatedBy
}</div>
              </td>

              {/* حالة التطبيق */}
              <td className="px-4 py-3">
                {transaction.TransactionType === 'خصم' ? (
                  <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                    transaction.IsApplied 
                      ? 'bg-green-100 text-green-800' 
                      : 'bg-yellow-100 text-yellow-800'
                  }`}>
                    {transaction.IsApplied ? '✅ مطبق' : '⏳ معلق'}
                  </span>
                ) : (
                  <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                    ✅ مطبق
                  </span>
                )}
              </td>

              {/* الإجراءات */}
              <td className="px-4 py-3">
                {canDo('حذف معاملة') && (
                <button
                  onClick={() => handleDeleteTransaction(transaction.TransactionId)}
                  className="text-red-600 hover:text-red-800 transition-colors p-1 rounded hover:bg-red-50"
                  title="حذف"
                >
                  <Trash2 size={16} />
                </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <div className="employee-mobile-card-list hidden mt-3 space-y-3">
      {transactions.map((transaction) => (
        <div key={`mobile-transaction-${transaction.TransactionId}`} className="employee-mobile-card">
          <div className="flex items-start justify-between gap-3 mb-3">
            <div>
              <div className="text-xs text-gray-500 mb-1">{formatDate(transaction.TransactionDate)}</div>
              <div className="text-lg font-bold text-gray-900">{transaction.Description || 'معاملة موظف'}</div>
            </div>
            <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-bold ${
              transaction.TransactionType === 'راتب' 
                ? 'bg-green-100 text-green-800'
                : transaction.TransactionType === 'سلفة'
                ? 'bg-orange-100 text-orange-800'
                : transaction.TransactionType === 'بونص'
                ? 'bg-blue-100 text-blue-800'
                : transaction.TransactionType === 'دفع قسط'
                ? 'bg-purple-100 text-purple-800'
                : 'bg-red-100 text-red-800'
            }`}>
              {transaction.TransactionType}
            </span>
          </div>
          <div className="employee-mobile-kv mb-3">
            <div>
              <div className="employee-mobile-label">المبلغ</div>
              <div className={`employee-mobile-value ${['راتب', 'بونص', 'سلفة'].includes(transaction.TransactionType) ? 'text-red-600' : 'text-green-600'}`}>
                {formatCurrency(transaction.Amount)}
              </div>
            </div>
            <div>
              <div className="employee-mobile-label">طريقة الدفع</div>
              <div className="employee-mobile-value">{transaction.PaymentMethodName || (transaction.TransactionType === 'خصم' ? 'معلق' : 'نقدي')}</div>
            </div>
            <div>
              <div className="employee-mobile-label">الشهر / السنة</div>
              <div className="employee-mobile-value">{transaction.SalaryMonth && transaction.SalaryYear ? `${getMonthName(transaction.SalaryMonth)} ${transaction.SalaryYear}` : '-'}</div>
            </div>
            <div>
              <div className="employee-mobile-label">أضيف بواسطة</div>
              <div className="employee-mobile-value">{transaction.CreatedByFullName || transaction.CreatedBy || '-'}</div>
            </div>
          </div>
          <div className="flex items-center justify-between gap-2 border-t pt-3">
            <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${transaction.TransactionType === 'خصم' && !transaction.IsApplied ? 'bg-yellow-100 text-yellow-800' : 'bg-blue-100 text-blue-800'}`}>
              {transaction.TransactionType === 'خصم' ? (transaction.IsApplied ? '✅ مطبق' : '⏳ معلق') : '✅ مطبق'}
            </span>
            {canDo('حذف معاملة') && (
              <button
                onClick={() => handleDeleteTransaction(transaction.TransactionId)}
                className="bg-red-50 text-red-700 px-3 py-2 rounded-xl text-sm font-bold flex items-center gap-2"
              >
                <Trash2 size={16} /> حذف
              </button>
            )}
          </div>
        </div>
      ))}
    </div>

  </div>
</div>

            </>
          ) : (
            <div className="text-center py-20">
              <User className="mx-auto text-gray-400 mb-4" size={64} />
              <p className="text-xl text-gray-600">اختر موظفاً لعرض معاملاته وسلفه</p>
            </div>
          )}
        </div>
      )}


{/* Transaction Form Modal - محدث */}
{showTransactionForm && (
  <div className="employee-mobile-modal fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold text-gray-800">
          {selectedEmployee ? `إضافة ${transactionFormData.transactionType} - ${selectedEmployee.EmployeeName}` : 'إضافة معاملة جديدة'}
        </h2>
        <button onClick={resetTransactionForm} className="text-gray-500 hover:text-gray-700">
          <X size={24} />
        </button>
      </div>
      
      <form onSubmit={handleTransactionSubmit} className="space-y-4">
        {!selectedEmployee && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">اختيار الموظف</label>
            <select
              value={transactionFormData.employeeId || ''}
              onChange={(e) => {
                const empId = parseInt(e.target.value);
                const emp = employees.find(e => e.EmployeeId === empId);
                setSelectedEmployee(emp);
                setTransactionFormData({...transactionFormData, employeeId: empId});
              }}
              className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            >
              <option value="">اختر الموظف</option>
              {employees.map(emp => (
                <option key={emp.EmployeeId} value={emp.EmployeeId}>
                  {emp.EmployeeName} - {emp.Position}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* إزالة نوع المعاملة إذا تم اختياره مسبقاً */}
        {!selectedEmployee && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">نوع المعاملة</label>
            <select
              value={transactionFormData.transactionType}
              onChange={(e) => setTransactionFormData({...transactionFormData, transactionType: e.target.value})}
              className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            >
              {/* إزالة خيار الراتب من هنا */}
              <option value="بونص">بونص</option>
              <option value="خصم">خصم</option>
              <option value="سلفة">سلفة</option>
            </select>
          </div>
        )}


        {/* نوع البونص - مُصحح */}
        {transactionFormData.transactionType === 'بونص' && (
          <>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">نوع البونص</label>
              <select
                value={transactionFormData.bonusType || 'with_salary'}
                onChange={(e) => setTransactionFormData({...transactionFormData, bonusType: e.target.value})}
                className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="with_salary">مع الراتب (يُحسب عند دفع الراتب)</option>
                <option value="direct">تحويل مباشر (من البنك فوراً)</option>
              </select>
            </div>

            {transactionFormData.bonusType === 'direct' && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">طريقة الدفع</label>
                <select
                  value={transactionFormData.paymentMethodId || ''}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    const selectedMethod = paymentMethods.find(pm => pm.id == selectedId);
                    setTransactionFormData({
                      ...transactionFormData,
                      paymentMethodId: selectedId ? parseInt(selectedId) : null,
                      paymentMethodType: selectedMethod ? selectedMethod.type : null
                    });
                  }}
                  className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                >
                  <option value="">اختر طريقة الدفع</option>
                  {paymentMethods.map(method => (
                    <option key={method.id} value={method.id}>
                      {method.Name} - {method.AccountNumber} 
                      {method.categoryName && ` (${method.categoryName})`}
                    </option>
                  ))}
                </select>
                <p className="text-xs text-gray-500 mt-1">
                  سيتم خصم المبلغ من الحساب فوراً ولن يُحسب مع الراتب
                </p>
              </div>
            )}
          </>
        )}

        {/* طريقة الدفع للراتب فقط */}
        {transactionFormData.transactionType === 'راتب' && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">طريقة الدفع</label>
            <select
              value={transactionFormData.paymentMethodId || ''}
              onChange={(e) => {
                const selectedId = e.target.value;
                const selectedMethod = paymentMethods.find(pm => pm.id == selectedId);
                setTransactionFormData({
                  ...transactionFormData,
                  paymentMethodId: selectedId ? parseInt(selectedId) : null,
                  paymentMethodType: selectedMethod ? selectedMethod.type : null
                });
              }}
              className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">اختر طريقة الدفع (اختياري)</option>
              {paymentMethods.map(method => (
                <option key={method.id} value={method.id}>
                  {method.Name} - {method.AccountNumber} 
                  {method.categoryName && ` (${method.categoryName})`}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* ملاحظة للخصم */}
        {transactionFormData.transactionType === 'خصم' && (
          <div className="bg-yellow-50 p-3 rounded-lg border border-yellow-200">
            <p className="text-sm text-yellow-800">
              💡 الخصم سيتم تطبيقه عند دفع الراتب التالي ولن يتم خصم أي مبلغ من البنك الآن
            </p>
          </div>
        )}
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">تاريخ المعاملة</label>
          <input
            type="date"
            value={transactionFormData.transactionDate}
            onChange={(e) => setTransactionFormData({...transactionFormData, transactionDate: e.target.value})}
            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">المبلغ</label>
          <input
            type="number"
            step="0.01"
            value={transactionFormData.amount}
            onChange={(e) => setTransactionFormData({...transactionFormData, amount: e.target.value})}
            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">الوصف</label>
          <textarea
            value={transactionFormData.description}
            onChange={(e) => setTransactionFormData({...transactionFormData, description: e.target.value})}
            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            rows="3"
            required
          />
        </div>

        {transactionFormData.transactionType === 'راتب' && (
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">شهر الراتب</label>
              <select
                value={transactionFormData.salaryMonth}
                onChange={(e) => setTransactionFormData({...transactionFormData, salaryMonth: parseInt(e.target.value)})}
                className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {[...Array(12)].map((_, i) => (
                  <option key={i} value={i + 1}>
                    {getMonthName(i + 1)}
                  </option>
                ))}
              </select>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">سنة الراتب</label>
              <select
                value={transactionFormData.salaryYear}
                onChange={(e) => setTransactionFormData({...transactionFormData, salaryYear: parseInt(e.target.value)})}
                className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {[...Array(3)].map((_, i) => (
                  <option key={i} value={new Date().getFullYear() - i}>
                    {new Date().getFullYear() - i}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}

        <div className="flex justify-end gap-4 pt-4">
          <button
            type="submit"
            className={`px-6 py-3 rounded-lg flex items-center gap-2 transition-colors text-white ${
              transactionFormData.transactionType === 'بونص' 
                ? 'bg-green-600 hover:bg-green-700'
                : transactionFormData.transactionType === 'راتب'
                ? 'bg-blue-600 hover:bg-blue-700'
                : transactionFormData.transactionType === 'سلفة'
                ? 'bg-orange-600 hover:bg-orange-700'
                : 'bg-red-600 hover:bg-red-700'
            }`}
          >
            <Save size={20} />
            حفظ {transactionFormData.transactionType}
          </button>
          <button
            type="button"
            onClick={resetTransactionForm}
            className="border border-gray-300 hover:bg-gray-50 text-gray-700 px-6 py-3 rounded-lg transition-colors"
          >
            إلغاء
          </button>
        </div>
      </form>
    </div>
  </div>
)}


{/* Advance Form Modal - محدث بحساب الأقساط التلقائي */}
{showAdvanceForm && (
  <div className="employee-mobile-modal fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg p-6 w-full max-w-lg mx-4 max-h-[90vh] overflow-y-auto">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold text-gray-800">إضافة سلفة جديدة</h2>
        <button onClick={resetAdvanceForm} className="text-gray-500 hover:text-gray-700">
          <X size={24} />
        </button>
      </div>
      
      <form onSubmit={handleAdvanceSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">تاريخ السلفة</label>
          <input
            type="date"
            value={advanceFormData.transactionDate}
            onChange={(e) => setAdvanceFormData({...advanceFormData, transactionDate: e.target.value})}
            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>

     <div>
  <label className="block text-sm font-medium text-gray-700 mb-2">
    طريقة الدفع <span className="text-red-600">*</span>
  </label>
  <select
    value={advanceFormData.paymentMethodId || ''}
    onChange={(e) => {
      const selectedId = e.target.value;
      const selectedMethod = paymentMethods.find(pm => pm.id == selectedId);
      setAdvanceFormData({
        ...advanceFormData,
        paymentMethodId: selectedId ? parseInt(selectedId) : null,
        paymentMethodType: selectedMethod ? selectedMethod.type : null
      });
    }}
    className="w-full border-2 border-red-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    required
  >
    <option value="">⚠️ يجب اختيار طريقة الدفع</option>
    {paymentMethods.map(method => (
      <option key={method.id} value={method.id}>
        {method.Name} - {method.AccountNumber}
        {method.categoryName && ` (${method.categoryName})`}
      </option>
    ))}
  </select>
  <div className="mt-2 p-3 bg-red-50 border border-red-200 rounded">
    <p className="text-sm text-red-700">
      ⚠️ <strong>مطلوب:</strong> يجب اختيار الحساب البنكي الذي سيتم سحب مبلغ السلفة منه
    </p>
    <p className="text-sm text-red-600 mt-1">
      سيتم خصم المبلغ من الحساب المحدد وستظهر المعاملة في سجل البنوك
    </p>
  </div>
  {!advanceFormData.paymentMethodId && (
    <div className="mt-2 p-2 bg-red-50 border border-red-200 rounded">
      <p className="text-xs text-red-700">
        ⚠️ يجب اختيار طريقة الدفع لحفظ المعاملة في السجلات البنكية
      </p>
    </div>
  )}
</div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">مبلغ السلفة</label>
          <input
            type="number"
            step="0.01"
            value={advanceFormData.amount}
            onChange={(e) => {
              const newAmount = parseFloat(e.target.value) || 0;
              const installmentAmount = parseFloat(advanceFormData.installmentAmount) || 0;
              const numberOfInstallments = installmentAmount > 0 ? Math.ceil(newAmount / installmentAmount) : 0;
              
              setAdvanceFormData({
                ...advanceFormData, 
                amount: e.target.value,
                numberOfInstallments: numberOfInstallments
              });
            }}
            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">وصف السلفة</label>
          <textarea
            value={advanceFormData.description}
            onChange={(e) => setAdvanceFormData({...advanceFormData, description: e.target.value})}
            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            rows="3"
            required
          />
        </div>

        <div className="flex items-center">
          <input
            type="checkbox"
            checked={advanceFormData.isInstallment}
            onChange={(e) => setAdvanceFormData({...advanceFormData, isInstallment: e.target.checked})}
            className="mr-2"
          />
          <label className="text-sm font-medium text-gray-700">تقسيط السلفة على أقساط شهرية</label>
        </div>

        {advanceFormData.isInstallment && (
          <>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">مبلغ القسط الشهري</label>
              <input
                type="number"
                step="0.01"
                value={advanceFormData.installmentAmount}
                onChange={(e) => {
                  const installmentAmount = parseFloat(e.target.value) || 0;
                  const totalAmount = parseFloat(advanceFormData.amount) || 0;
                  const numberOfInstallments = installmentAmount > 0 ? Math.ceil(totalAmount / installmentAmount) : 0;
                  
                  setAdvanceFormData({
                    ...advanceFormData, 
                    installmentAmount: e.target.value,
                    numberOfInstallments: numberOfInstallments
                  });
                }}
                className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                required={advanceFormData.isInstallment}
              />
              {advanceFormData.installmentAmount && advanceFormData.amount && (
                <p className="text-sm text-blue-600 mt-1">
                  عدد الأقساط المحسوب: {Math.ceil(parseFloat(advanceFormData.amount) / parseFloat(advanceFormData.installmentAmount))} قسط
                </p>
              )}
            </div>

            {/* عرض عدد الأقساط المحسوب فقط للقراءة */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">عدد الأقساط (محسوب تلقائياً)</label>
              <input
                type="number"
                value={advanceFormData.numberOfInstallments}
                disabled
                className="w-full border border-gray-300 rounded-lg p-3 bg-gray-100 text-gray-600"
              />
              <p className="text-xs text-gray-500 mt-1">
                يتم حساب عدد الأقساط تلقائياً: إجمالي السلفة ÷ القسط الشهري
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">شهر بداية الخصم</label>
                <select
                  value={advanceFormData.startDeductionMonth}
                  onChange={(e) => setAdvanceFormData({...advanceFormData, startDeductionMonth: parseInt(e.target.value)})}
                  className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  {[...Array(12)].map((_, i) => (
                    <option key={i} value={i + 1}>
                      {getMonthName(i + 1)}
                    </option>
                  ))}
                </select>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">سنة بداية الخصم</label>
                <select
                  value={advanceFormData.startDeductionYear}
                  onChange={(e) => setAdvanceFormData({...advanceFormData, startDeductionYear: parseInt(e.target.value)})}
                  className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  {[...Array(3)].map((_, i) => (
                    <option key={i} value={new Date().getFullYear() + i}>
                      {new Date().getFullYear() + i}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* عرض ملخص التقسيط */}
            {advanceFormData.amount && advanceFormData.installmentAmount && (
              <div className="bg-blue-50 p-3 rounded-lg border border-blue-200">
                <h4 className="font-medium text-blue-800 mb-2">ملخص التقسيط:</h4>
                <div className="text-sm text-blue-700 space-y-1">
                  <div>إجمالي السلفة: {formatCurrency(parseFloat(advanceFormData.amount))}</div>
                  <div>القسط الشهري: {formatCurrency(parseFloat(advanceFormData.installmentAmount))}</div>
                  <div>عدد الأقساط: {Math.ceil(parseFloat(advanceFormData.amount) / parseFloat(advanceFormData.installmentAmount))} قسط</div>
                  <div>بداية الخصم: {getMonthName(advanceFormData.startDeductionMonth)} {advanceFormData.startDeductionYear}</div>
                </div>
              </div>
            )}
          </>
        )}

        <div className="flex justify-end gap-4 pt-4">
         <button
  type="submit"
  disabled={!advanceFormData.paymentMethodId}
  className={`px-6 py-3 rounded-lg flex items-center gap-2 transition-colors text-white ${
    advanceFormData.paymentMethodId
      ? 'bg-orange-600 hover:bg-orange-700'
      : 'bg-gray-400 cursor-not-allowed'
  }`}
>
  <Save size={20} />
  {advanceFormData.paymentMethodId ? 'حفظ السلفة' : 'اختر طريقة الدفع أولاً'}
</button>
          <button
            type="button"
            onClick={resetAdvanceForm}
            className="border border-gray-300 hover:bg-gray-50 text-gray-700 px-6 py-3 rounded-lg transition-colors"
          >
            إلغاء
          </button>
        </div>
      </form>
    </div>
  </div>
)}





{/* Installment Payment Modal - محسن ومنسق */}
{showInstallmentForm && (
  <div className="employee-mobile-modal fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg p-6 w-full max-w-lg mx-4 max-h-[90vh] overflow-y-auto">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold text-gray-800">دفع قسط من السلفة</h2>
        <button onClick={resetInstallmentForm} className="text-gray-500 hover:text-gray-700">
          <X size={24} />
        </button>
      </div>
      
      <form onSubmit={handleInstallmentPayment} className="space-y-4">
        {/* تاريخ الدفع */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <Calendar className="inline ml-1" size={16} />
            تاريخ الدفع
          </label>
          <input
            type="date"
            value={installmentFormData.paymentDate}
            onChange={(e) => setInstallmentFormData({...installmentFormData, paymentDate: e.target.value})}
            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>

        {/* مبلغ القسط */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <DollarSign className="inline ml-1" size={16} />
            مبلغ القسط
          </label>
          <input
            type="number"
            step="0.01"
            value={installmentFormData.amount}
            onChange={(e) => setInstallmentFormData({...installmentFormData, amount: e.target.value})}
            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="أدخل مبلغ القسط"
            required
          />
          <div className="mt-2 p-2 bg-blue-50 border border-blue-200 rounded">
            <p className="text-xs text-blue-700">
              💡 <strong>مرونة في الدفع:</strong> يمكن دفع أي مبلغ، وسيتم إعادة حساب الأقساط المتبقية تلقائياً
            </p>
          </div>
        </div>

        {/* طريقة الدفع */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <CreditCard className="inline ml-1" size={16} />
            طريقة الدفع <span className="text-red-600">*</span>
          </label>
          <select
            value={installmentFormData.paymentMethodId || ''}
            onChange={(e) => {
              const selectedId = e.target.value;
              const selectedMethod = paymentMethods.find(pm => pm.id == selectedId);
              setInstallmentFormData({
                ...installmentFormData,
                paymentMethodId: selectedId ? parseInt(selectedId) : null,
                paymentMethodType: selectedMethod ? selectedMethod.type : null
              });
            }}
            className="w-full border-2 border-blue-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            required
          >
            <option value="">🏦 اختر الحساب البنكي للإيداع</option>
            {paymentMethods.map(method => (
              <option key={method.id} value={method.id}>
                {method.Name} - {method.AccountNumber}
                {method.categoryName && ` (${method.categoryName})`}
              </option>
            ))}
          </select>
          
          {!installmentFormData.paymentMethodId && (
            <div className="mt-2 p-3 bg-red-50 border border-red-200 rounded">
              <p className="text-sm text-red-700">
                ⚠️ <strong>مطلوب:</strong> يجب اختيار الحساب البنكي الذي سيتم إيداع القسط فيه
              </p>
            </div>
          )}
          
          {installmentFormData.paymentMethodId && (
            <div className="mt-2 p-3 bg-green-50 border border-green-200 rounded">
              <p className="text-sm text-green-700">
                ✅ <strong>تم الاختيار:</strong> سيتم إيداع المبلغ في الحساب المحدد
              </p>
            </div>
          )}
        </div>
        
        {/* الوصف والملاحظات */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <FileText className="inline ml-1" size={16} />
            وصف الدفعة
          </label>
          <textarea
            value={installmentFormData.description}
            onChange={(e) => setInstallmentFormData({...installmentFormData, description: e.target.value})}
            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            rows="3"
            placeholder="أدخل أي ملاحظات إضافية حول هذه الدفعة..."
          />
        </div>

        {/* معلومات توضيحية */}
        <div className="bg-gradient-to-r from-green-50 to-blue-50 p-4 rounded-lg border border-green-200">
          <div className="flex items-start space-x-2 space-x-reverse">
            <CheckCircle className="text-green-600 mt-0.5 flex-shrink-0" size={20} />
            <div className="text-sm">
              <p className="font-medium text-green-800 mb-2">سيتم تسجيل دفع القسط في:</p>
              <ul className="space-y-1 text-green-700">
                <li className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-green-500 rounded-full"></span>
                  سجل معاملات الموظف
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-green-500 rounded-full"></span>
                  سجل السلفة والأقساط
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-green-500 rounded-full"></span>
                  الحساب البنكي المحدد
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-green-500 rounded-full"></span>
                  سجل المعاملات البنكية
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* تحذير إضافي */}
        {!installmentFormData.paymentMethodId && (
          <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-200">
            <div className="flex items-start space-x-2 space-x-reverse">
              <AlertCircle className="text-yellow-600 mt-0.5 flex-shrink-0" size={20} />
              <div className="text-sm text-yellow-800">
                <p className="font-medium mb-1">تأكد من اختيار طريقة الدفع!</p>
                <p>بدون طريقة الدفع لن تتم عملية دفع القسط ولن تظهر في صفحة البنوك</p>
              </div>
            </div>
          </div>
        )}

        {/* أزرار الإجراءات */}
        <div className="flex justify-end gap-3 pt-6 border-t border-gray-200">
          <button
            type="submit"
            disabled={!installmentFormData.paymentMethodId || !installmentFormData.amount}
            className={`px-6 py-3 rounded-lg flex items-center gap-2 transition-colors font-medium ${
              installmentFormData.paymentMethodId && installmentFormData.amount
                ? 'bg-blue-600 hover:bg-blue-700 text-white shadow-md hover:shadow-lg'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
          >
            <Save size={20} />
            {installmentFormData.paymentMethodId && installmentFormData.amount ? 'دفع القسط' : 'أكمل البيانات المطلوبة'}
          </button>
          <button
            type="button"
            onClick={resetInstallmentForm}
            className="border border-gray-300 hover:bg-gray-50 text-gray-700 px-6 py-3 rounded-lg transition-colors font-medium"
          >
            إلغاء
          </button>
        </div>
      </form>
    </div>
  </div>
)}

{showSmartSalaryForm && smartSalaryData.salarySummary && (
  <div className="employee-mobile-modal fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg p-6 w-full max-w-2xl mx-4 max-h-[90vh] overflow-y-auto">
      <h2 className="text-xl font-bold text-gray-800 mb-4">دفع راتب مع تطبيق الخصومات</h2>
      
      {/* إذا كان الراتب مدفوع بالفعل */}
      {smartSalaryData.salarySummary.isFullyPaid ? (
        <div className="text-center py-8">
          <div className="bg-green-100 rounded-full w-24 h-24 mx-auto mb-4 flex items-center justify-center">
            <CheckCircle className="text-green-600" size={48} />
          </div>
          <h3 className="text-xl font-bold text-green-800 mb-2">تم دفع راتب هذا الشهر بالفعل!</h3>
          <p className="text-gray-600 mb-4">
            تم دفع راتب {smartSalaryData.salarySummary.employeeName} لشهر {getMonthName(smartSalaryData.salarySummary.month)} {smartSalaryData.salarySummary.year}
          </p>
          <div className="bg-gray-50 p-4 rounded-lg">
            <div className="text-sm space-y-2">
              <div className="flex justify-between">
                <span>المبلغ المدفوع:</span>
                <span className="font-medium text-green-600">{formatCurrency(smartSalaryData.salarySummary.totalSalaryPaid)}</span>
              </div>
            </div>
          </div>
          <button
            onClick={() => setShowSmartSalaryForm(false)}
            className="mt-6 bg-gray-600 hover:bg-gray-700 text-white px-6 py-3 rounded-lg transition-colors"
          >
            إغلاق
          </button>
        </div>
      ) : (
        <>
          <div className="bg-blue-50 p-4 rounded-lg mb-4">
            <h3 className="font-bold mb-2">{smartSalaryData.salarySummary.employeeName}</h3>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span>الراتب الأساسي:</span>
                <span className="font-medium">{formatCurrency(smartSalaryData.salarySummary.basicSalary)}</span>
              </div>
              <div className="flex justify-between">
                <span>البونصات:</span>
                <span className="font-medium text-green-600">{formatCurrency(smartSalaryData.salarySummary.totalBonuses)}</span>
              </div>
              <div className="flex justify-between">
                <span>إجمالي الراتب:</span>
                <span className="font-medium">{formatCurrency(smartSalaryData.salarySummary.grossSalary)}</span>
              </div>
              <div className="flex justify-between">
                <span>خصم السلف:</span>
                <span className="font-medium text-orange-600">{formatCurrency(smartSalaryData.salarySummary.totalAdvances)}</span>
              </div>
              <div className="flex justify-between">
                <span>المدفوع سابقاً:</span>
                <span className="font-medium text-green-600">{formatCurrency(smartSalaryData.salarySummary.totalSalaryPaid)}</span>
              </div>
            </div>
          </div>

          {/* عرض الخصومات المعلقة */}
          {smartSalaryData.pendingDeductions && smartSalaryData.pendingDeductions.count > 0 && (
            <div className="bg-red-50 p-4 rounded-lg mb-4 border border-red-200">
              <h4 className="font-bold text-red-800 mb-2">
                خصومات معلقة ({smartSalaryData.pendingDeductions.count})
              </h4>
              <div className="space-y-2 max-h-32 overflow-y-auto">
                {smartSalaryData.pendingDeductions.pendingDeductions.map((deduction, index) => (
                  <div key={index} className="flex justify-between items-center text-sm">
                    <span>{deduction.Description}</span>
                    <span className="font-medium text-red-600">
                      {formatCurrency(deduction.Amount)}
                    </span>
                  </div>
                ))}
              </div>
              <div className="border-t border-red-300 pt-2 mt-2">
                <div className="flex justify-between font-bold text-red-800">
                  <span>إجمالي الخصومات المعلقة:</span>
                  <span>{formatCurrency(smartSalaryData.pendingDeductions.totalAmount)}</span>
                </div>
              </div>
            </div>
          )}

          <div className="bg-green-50 p-4 rounded-lg mb-4 border border-green-200">
            <div className="flex justify-between font-bold text-lg text-green-800">
              <span>صافي المبلغ المستحق:</span>
              <span>{formatCurrency(smartSalaryData.salarySummary.finalNetSalary)}</span>
            </div>
            <div className="flex justify-between text-sm text-green-600 mt-1">
              <span>المتبقي للدفع:</span>
              <span>{formatCurrency(smartSalaryData.salarySummary.remainingSalary)}</span>
            </div>
          </div>

          <form onSubmit={(e) => {
            e.preventDefault();
            const formData = new FormData(e.target);
            
            const paymentMethodId = formData.get('paymentMethodId');
            const salaryData = {
              salaryAmount: parseFloat(formData.get('amount')),
              description: formData.get('description'),
              salaryMonth: parseInt(formData.get('salaryMonth')),
              salaryYear: parseInt(formData.get('salaryYear')),
              transactionDate: formData.get('paymentDate'),
              paymentMethodId: paymentMethodId ? parseInt(paymentMethodId) : null,
              paymentMethodType: paymentMethodId ? 'bank' : null
            };
            
            console.log('🔍 بيانات الراتب المرسلة:', salaryData);
            
            paymentSalaryWithDeductions(smartSalaryData.employeeId, salaryData);
            setShowSmartSalaryForm(false);
          }}>
            
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">تاريخ الدفع</label>
                <input
                  name="paymentDate"
                  type="date"
                  defaultValue={new Date().toISOString().split('T')[0]}
                  className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  طريقة الدفع <span className="text-red-600">*</span>
                </label>
                <select
                  name="paymentMethodId"
                  className="w-full border-2 border-red-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  required
                >
                  <option value="">⚠️ يجب اختيار طريقة الدفع لتظهر في البنوك</option>
                  {paymentMethods.map(method => (
                    <option key={method.id} value={method.id}>
                      {method.Name} - {method.AccountNumber}
                      {method.categoryName && ` (${method.categoryName})`}
                    </option>
                  ))}
                </select>
                <div className="mt-2 p-2 bg-red-50 border border-red-200 rounded">
                  <p className="text-xs text-red-700">
                    ⚠️ <strong>مهم:</strong> بدون اختيار طريقة الدفع لن تظهر المعاملة في صفحة البنوك
                  </p>
                  <p className="text-xs text-red-600 mt-1">
                    سيتم خصم المبلغ من الحساب المحدد وستظهر المعاملة في سجل البنوك
                  </p>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">المبلغ المطلوب دفعه</label>
                <input
                  name="amount"
                  type="number"
                  step="0.01"
                  max={smartSalaryData.salarySummary.remainingSalary}
                  defaultValue={smartSalaryData.salarySummary.remainingSalary}
                  className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
                <p className="text-xs text-gray-500 mt-1">
                  الحد الأقصى: {formatCurrency(smartSalaryData.salarySummary.remainingSalary)}
                </p>
                {smartSalaryData.pendingDeductions && smartSalaryData.pendingDeductions.count > 0 && (
                  <p className="text-xs text-red-600 mt-1">
                    تنبيه: سيتم خصم {formatCurrency(smartSalaryData.pendingDeductions.totalAmount)} من هذا المبلغ تلقائياً
                  </p>
                )}
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">شهر الراتب</label>
                  <select
                    name="salaryMonth"
                    defaultValue={smartSalaryData.selectedMonth || statusMonth}
                    className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    {[...Array(12)].map((_, i) => (
                      <option key={i} value={i + 1}>
                        مرتب شهر {getMonthName(i + 1)}
                      </option>
                    ))}
                  </select>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">سنة الراتب</label>
                  <select
                    name="salaryYear"
                    defaultValue={smartSalaryData.selectedYear || statusYear}
                    className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    {[...Array(3)].map((_, i) => (
                      <option key={i} value={new Date().getFullYear() - i}>
                        {new Date().getFullYear() - i}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">الوصف</label>
                <input
                  name="description"
                  type="text"
                  defaultValue={`راتب شهر ${getMonthName(smartSalaryData.selectedMonth || statusMonth)} ${smartSalaryData.selectedYear || statusYear}`}
                  className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              {/* تحذير إضافي */}
              <div className="bg-yellow-50 p-3 rounded-lg border border-yellow-200">
                <div className="flex items-start space-x-2 space-x-reverse">
                  <AlertCircle className="text-yellow-600 mt-0.5" size={16} />
                  <div className="text-sm text-yellow-800">
                    <p className="font-medium">تأكد من اختيار طريقة الدفع!</p>
                    <p>بدون طريقة الدفع لن تظهر هذه المعاملة في صفحة إدارة البنوك والمحافظ</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-end gap-4 pt-4">
              <button
                type="submit"
                className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg transition-colors flex items-center gap-2"
              >
                <DollarSign size={20} />
                دفع الراتب مع تطبيق الخصومات
              </button>
              <button
                type="button"
                onClick={() => setShowSmartSalaryForm(false)}
                className="border border-gray-300 hover:bg-gray-50 text-gray-700 px-6 py-3 rounded-lg transition-colors"
              >
                إلغاء
              </button>
            </div>
          </form>
        </>
      )}
    </div>
  </div>
)}

      {/* Employee Form Modal */}
      {showEmployeeForm && (
        <div className="employee-mobile-modal fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-2xl mx-4 max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-gray-800">
                {editingId ? 'تعديل الموظف' : 'إضافة موظف جديد'}
              </h2>
              <button onClick={resetEmployeeForm} className="text-gray-500 hover:text-gray-700">
                <X size={24} />
              </button>
            </div>
            
            <form onSubmit={handleEmployeeSubmit} className="space-y-4">
              {/* قسم الصورة الشخصية */}
              <div className="flex justify-center mb-6">
                <div className="relative">
                  <div className="w-32 h-32 rounded-full border-4 border-gray-200 overflow-hidden bg-gray-100 flex items-center justify-center">
                    {imagePreview ? (
                      <img 
                        src={imagePreview} 
                        alt="معاينة الصورة" 
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <User size={48} className="text-gray-400" />
                    )}
                  </div>
                  <label className="absolute bottom-0 right-0 bg-blue-600 text-white rounded-full p-2 cursor-pointer hover:bg-blue-700 transition-colors">
                    <Camera size={20} />
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                      className="hidden"
                    />
                  </label>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">اسم الموظف</label>
                  <input
                    type="text"
                    value={employeeFormData.employeeName}
                    onChange={(e) => setEmployeeFormData({...employeeFormData, employeeName: e.target.value})}
                    className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">المنصب</label>
                  <input
                    type="text"
                    value={employeeFormData.position}
                    onChange={(e) => setEmployeeFormData({...employeeFormData, position: e.target.value})}
                    className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">الراتب الأساسي</label>
                  <input
                    type="number"
                    step="0.01"
                    value={employeeFormData.basicSalary}
                    onChange={(e) => setEmployeeFormData({...employeeFormData, basicSalary: e.target.value})}
                    className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">رقم الهاتف</label>
                  <input
                    type="tel"
                    value={employeeFormData.phone}
                    onChange={(e) => setEmployeeFormData({...employeeFormData, phone: e.target.value})}
                    className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">البريد الإلكتروني</label>
                  <input
                    type="email"
                    value={employeeFormData.email}
                    onChange={(e) => setEmployeeFormData({...employeeFormData, email: e.target.value})}
                    className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">تاريخ التوظيف</label>
                  <input
                    type="date"
                    value={employeeFormData.hireDate}
                    onChange={(e) => setEmployeeFormData({...employeeFormData, hireDate: e.target.value})}
                    className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">ملاحظات</label>
                <textarea
                  value={employeeFormData.notes}
                  onChange={(e) => setEmployeeFormData({...employeeFormData, notes: e.target.value})}
                  className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows="3"
                />
              </div>

           <div className="flex justify-end gap-4 pt-4">
  <button
    type="submit"
    disabled={isSubmitting}
    className={`px-6 py-3 rounded-lg flex items-center gap-2 transition-colors text-white ${
      isSubmitting 
        ? 'bg-gray-400 cursor-not-allowed' 
        : 'bg-blue-600 hover:bg-blue-700'
    }`}
  >
    <Save size={20} />
    {isSubmitting ? 'جاري الحفظ...' : (editingId ? 'تحديث' : 'حفظ')}
  </button>
  <button
    type="button"
    onClick={resetEmployeeForm}
    disabled={isSubmitting}
    className="border border-gray-300 hover:bg-gray-50 text-gray-700 px-6 py-3 rounded-lg transition-colors"
  >
    إلغاء
  </button>
</div>
            </form>
          </div>
        </div>
      )}

{/* Edit Advance Form Modal - محدث بمنع تعديل مبلغ السلفة */}
{showEditAdvanceForm && (
  <div className="employee-mobile-modal fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg p-6 w-full max-w-lg mx-4 max-h-[90vh] overflow-y-auto">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold text-gray-800">تعديل السلفة</h2>
        <button onClick={resetEditAdvanceForm} className="text-gray-500 hover:text-gray-700">
          <X size={24} />
        </button>
      </div>
      
      <form onSubmit={handleEditAdvanceSubmit} className="space-y-4">
        {/* عرض المبلغ الأصلي كقراءة فقط */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">المبلغ الأصلي للسلفة</label>
          <input
            type="number"
            step="0.01"
            value={editAdvanceFormData.amount}
            disabled
            className="w-full border border-gray-300 rounded-lg p-3 bg-gray-100 text-gray-600 cursor-not-allowed"
          />
          <p className="text-xs text-gray-500 mt-1">
            لا يمكن تعديل المبلغ الأصلي للسلفة لأسباب محاسبية
          </p>
        </div>

        {/* عرض المبلغ المدفوع والمتبقي */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">المبلغ المدفوع</label>
            <input
              type="number"
              step="0.01"
              value={editAdvanceFormData.paidAmount || 0}
              disabled
              className="w-full border border-gray-300 rounded-lg p-3 bg-green-50 text-green-700 cursor-not-allowed"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">المبلغ المتبقي</label>
            <input
              type="number"
              step="0.01"
              value={editAdvanceFormData.remainingAmount || 0}
              disabled
              className="w-full border border-gray-300 rounded-lg p-3 bg-orange-50 text-orange-700 cursor-not-allowed"
            />
          </div>
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">وصف السلفة</label>
          <textarea
            value={editAdvanceFormData.description}
            onChange={(e) => setEditAdvanceFormData({...editAdvanceFormData, description: e.target.value})}
            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            rows="3"
            required
          />
        </div>

        <div className="flex items-center">
          <input
            type="checkbox"
            checked={editAdvanceFormData.isInstallment}
            onChange={(e) => setEditAdvanceFormData({...editAdvanceFormData, isInstallment: e.target.checked})}
            className="mr-2"
          />
          <label className="text-sm font-medium text-gray-700">تقسيط السلفة على أقساط شهرية</label>
        </div>

        {editAdvanceFormData.isInstallment && (
          <>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                مبلغ القسط الشهري الجديد
                <span className="text-blue-600 text-xs block">
                  (سيتم تطبيقه على المبلغ المتبقي: {formatCurrency(editAdvanceFormData.remainingAmount || 0)})
                </span>
              </label>
              <input
                type="number"
                step="0.01"
                value={editAdvanceFormData.installmentAmount}
                onChange={(e) => {
                  const installmentAmount = parseFloat(e.target.value) || 0;
                  const remainingAmount = parseFloat(editAdvanceFormData.remainingAmount) || 0;
                  const numberOfInstallments = installmentAmount > 0 ? Math.ceil(remainingAmount / installmentAmount) : 0;
                  
                  setEditAdvanceFormData({
                    ...editAdvanceFormData, 
                    installmentAmount: e.target.value,
                    numberOfInstallments: numberOfInstallments
                  });
                }}
                className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                required={editAdvanceFormData.isInstallment}
                max={editAdvanceFormData.remainingAmount}
              />
              {editAdvanceFormData.installmentAmount && editAdvanceFormData.remainingAmount && (
                <p className="text-sm text-blue-600 mt-1">
                  عدد الأقساط المحسوب: {Math.ceil(parseFloat(editAdvanceFormData.remainingAmount) / parseFloat(editAdvanceFormData.installmentAmount))} قسط
                </p>
              )}
            </div>

            {/* عرض عدد الأقساط المحسوب فقط للقراءة */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">عدد الأقساط المتبقية (محسوب تلقائياً)</label>
              <input
                type="number"
                value={editAdvanceFormData.numberOfInstallments}
                disabled
                className="w-full border border-gray-300 rounded-lg p-3 bg-gray-100 text-gray-600"
              />
              <p className="text-xs text-gray-500 mt-1">
                يتم حساب عدد الأقساط تلقائياً: المبلغ المتبقي ÷ القسط الشهري الجديد
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">شهر بداية الخصم</label>
                <select
                  value={editAdvanceFormData.startDeductionMonth}
                  onChange={(e) => setEditAdvanceFormData({...editAdvanceFormData, startDeductionMonth: parseInt(e.target.value)})}
                  className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  {[...Array(12)].map((_, i) => (
                    <option key={i} value={i + 1}>
                      {getMonthName(i + 1)}
                    </option>
                  ))}
                </select>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">سنة بداية الخصم</label>
                <select
                  value={editAdvanceFormData.startDeductionYear}
                  onChange={(e) => setEditAdvanceFormData({...editAdvanceFormData, startDeductionYear: parseInt(e.target.value)})}
                  className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  {[...Array(3)].map((_, i) => (
                    <option key={i} value={new Date().getFullYear() + i}>
                      {new Date().getFullYear() + i}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* عرض ملخص التقسيط */}
            {editAdvanceFormData.remainingAmount && editAdvanceFormData.installmentAmount && (
              <div className="bg-yellow-50 p-3 rounded-lg border border-yellow-200">
                <h4 className="font-medium text-yellow-800 mb-2">ملخص التقسيط الجديد:</h4>
                <div className="text-sm text-yellow-700 space-y-1">
                  <div>المبلغ المتبقي: {formatCurrency(parseFloat(editAdvanceFormData.remainingAmount))}</div>
                  <div>القسط الشهري الجديد: {formatCurrency(parseFloat(editAdvanceFormData.installmentAmount))}</div>
                  <div>عدد الأقساط المتبقية: {Math.ceil(parseFloat(editAdvanceFormData.remainingAmount) / parseFloat(editAdvanceFormData.installmentAmount))} قسط</div>
                  <div>بداية الخصم: {getMonthName(editAdvanceFormData.startDeductionMonth)} {editAdvanceFormData.startDeductionYear}</div>
                </div>
              </div>
            )}
          </>
        )}

        <div className="flex justify-end gap-4 pt-4">
          <button
            type="submit"
            className="bg-yellow-600 hover:bg-yellow-700 text-white px-6 py-3 rounded-lg flex items-center gap-2 transition-colors"
          >
            <Save size={20} />
            تحديث السلفة
          </button>
          <button
            type="button"
            onClick={resetEditAdvanceForm}
            className="border border-gray-300 hover:bg-gray-50 text-gray-700 px-6 py-3 rounded-lg transition-colors"
          >
            إلغاء
          </button>
        </div>
      </form>
    </div>
  </div>
)}
      {/* Employee History Tab - كامل */}
      {activeTab === 'employee-history' && (
        <div className="bg-white rounded-lg shadow-lg p-6">
          {selectedEmployee ? (
            <>
              <div className="flex justify-between items-center mb-6">
                <div>
                  <h2 className="text-2xl font-bold text-gray-800">سجل الموظف: {selectedEmployee.EmployeeName}</h2>
                  <p className="text-gray-600">المنصب: {selectedEmployee.Position} | الراتب الأساسي: {formatCurrency(selectedEmployee.BasicSalary)}</p>
                </div>
              </div>

              {/* ملخص سنوي */}
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                <div className="bg-green-50 p-4 rounded-lg border border-green-200">
                  <div className="text-sm text-green-600 font-medium">إجمالي الرواتب</div>
                  <div className="text-2xl font-bold text-green-700">
                    {formatCurrency(employeeHistory.reduce((sum, month) => sum + (month.PaidSalary || 0), 0))}
                  </div>
                </div>
                
                <div className="bg-orange-50 p-4 rounded-lg border border-orange-200">
                  <div className="text-sm text-orange-600 font-medium">إجمالي السلف</div>
                  <div className="text-2xl font-bold text-orange-700">
                    {formatCurrency(employeeHistory.reduce((sum, month) => sum + (month.TotalAdvance || 0), 0))}
                  </div>
                </div>
                
                <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                  <div className="text-sm text-blue-600 font-medium">إجمالي البونصات</div>
                  <div className="text-2xl font-bold text-blue-700">
                    {formatCurrency(employeeHistory.reduce((sum, month) => sum + (month.TotalBonus || 0), 0))}
                  </div>
                </div>
                
                <div className="bg-red-50 p-4 rounded-lg border border-red-200">
                  <div className="text-sm text-red-600 font-medium">إجمالي الخصومات</div>
                  <div className="text-2xl font-bold text-red-700">
                    {formatCurrency(employeeHistory.reduce((sum, month) => sum + (month.TotalDeduction || 0), 0))}
                  </div>
                </div>
              </div>

              {/* السجل الشهري */}
              <div className="employee-desktop-table overflow-x-auto">
                <table className="w-full border-collapse bg-white">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 p-3 text-right">الشهر/السنة</th>
                      <th className="border border-gray-300 p-3 text-right">الراتب المدفوع</th>
                      <th className="border border-gray-300 p-3 text-right">السلف</th>
                      <th className="border border-gray-300 p-3 text-right">البونصات</th>
                      <th className="border border-gray-300 p-3 text-right">الخصومات</th>
                      <th className="border border-gray-300 p-3 text-right">الحالة</th>
                      <th className="border border-gray-300 p-3 text-right">الإجراءات</th>
                    </tr>
                  </thead>
                  <tbody>
                    {employeeHistory.map((monthData) => (
                      <tr key={`${monthData.Month}-${monthData.Year}`} className="hover:bg-gray-50">
                        <td className="border border-gray-300 p-3 font-medium">
                          {getMonthName(monthData.Month)} {monthData.Year}
                        </td>
                        <td className="border border-gray-300 p-3 text-green-600">
                          {formatCurrency(monthData.PaidSalary)}
                        </td>
                        <td className="border border-gray-300 p-3 text-orange-600">
                          {formatCurrency(monthData.TotalAdvance)}
                        </td>
                        <td className="border border-gray-300 p-3 text-blue-600">
                          {formatCurrency(monthData.TotalBonus)}
                        </td>
                        <td className="border border-gray-300 p-3 text-red-600">
                          {formatCurrency(monthData.TotalDeduction)}
                        </td>
                        <td className="border border-gray-300 p-3">
                          <span className={`px-2 py-1 rounded-full text-xs ${getStatusColor(monthData.PaymentStatus)}`}>
                            {monthData.PaymentStatus}
                          </span>
                        </td>
                        <td className="border border-gray-300 p-3">
                          {monthData.RemainingSalary > 0 && (
                            <button
                              onClick={async () => {
                                const response = await fetch(`${config.API_BASE_URL}/api/employees/${selectedEmployee.EmployeeId}/salary-summary/${monthData.Month}/${monthData.Year}`);
                                const salarySummary = await response.json();
                                
                                setSmartSalaryData({
                                  employeeId: selectedEmployee.EmployeeId,
                                  employeeName: selectedEmployee.EmployeeName,
                                  salarySummary: salarySummary,
                                  suggestedAmount: Math.max(0, salarySummary?.remainingSalary || 0),
                                  maxAmount: Math.max(0, salarySummary?.remainingSalary || 0),
                                  selectedMonth: monthData.Month,
                                  selectedYear: monthData.Year
                                });
                                setShowSmartSalaryForm(true);
                              }}
                              className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-xs transition-colors"
                            >
                              دفع راتب
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="employee-mobile-card-list hidden mt-3 space-y-3">
                {employeeHistory.map((monthData) => (
                  <div key={`mobile-history-${monthData.Month}-${monthData.Year}`} className="employee-mobile-card">
                    <div className="flex items-center justify-between gap-2 mb-3">
                      <div className="text-lg font-bold text-gray-900">{getMonthName(monthData.Month)} {monthData.Year}</div>
                      <span className={`px-3 py-1 rounded-full text-xs font-bold ${getStatusColor(monthData.PaymentStatus)}`}>
                        {monthData.PaymentStatus}
                      </span>
                    </div>
                    <div className="employee-mobile-kv mb-3">
                      <div><div className="employee-mobile-label">الراتب المدفوع</div><div className="employee-mobile-value text-green-600">{formatCurrency(monthData.PaidSalary)}</div></div>
                      <div><div className="employee-mobile-label">السلف</div><div className="employee-mobile-value text-orange-600">{formatCurrency(monthData.TotalAdvance)}</div></div>
                      <div><div className="employee-mobile-label">البونصات</div><div className="employee-mobile-value text-blue-600">{formatCurrency(monthData.TotalBonus)}</div></div>
                      <div><div className="employee-mobile-label">الخصومات</div><div className="employee-mobile-value text-red-600">{formatCurrency(monthData.TotalDeduction)}</div></div>
                    </div>
                    {monthData.RemainingSalary > 0 && (
                      <button
                        onClick={async () => {
                          const response = await fetch(`${config.API_BASE_URL}/api/employees/${selectedEmployee.EmployeeId}/salary-summary/${monthData.Month}/${monthData.Year}`);
                          const salarySummary = await response.json();
                          setSmartSalaryData({
                            employeeId: selectedEmployee.EmployeeId,
                            employeeName: selectedEmployee.EmployeeName,
                            salarySummary: salarySummary,
                            suggestedAmount: Math.max(0, salarySummary?.remainingSalary || 0),
                            maxAmount: Math.max(0, salarySummary?.remainingSalary || 0),
                            selectedMonth: monthData.Month,
                            selectedYear: monthData.Year
                          });
                          setShowSmartSalaryForm(true);
                        }}
                        className="w-full bg-green-600 hover:bg-green-700 text-white px-4 py-3 rounded-xl text-sm font-bold"
                      >
                        دفع راتب
                      </button>
                    )}
                  </div>
                ))}
              </div>

            </>
          ) : (
            <div className="text-center py-20">
              <BarChart3 className="mx-auto text-gray-400 mb-4" size={64} />
              <p className="text-xl text-gray-600">اختر موظفاً لعرض سجله التاريخي</p>
            </div>
          )}
        </div>
      )}

      {/* Employees Tab - كامل */}
      {activeTab === 'employees' && (
        <div className="bg-white rounded-lg shadow-lg p-6">
          <div className="flex justify-between items-center mb-6">
         {canDo('إضافة موظف') && (
         <button 
  className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg flex items-center gap-2 transition-colors"
  onClick={() => {
    setIsSubmitting(false); // تأكد من إعادة التعيين
    setShowEmployeeForm(true);
  }}
>
  <Plus size={20} />
  إضافة موظف جديد
</button>
         )}
            <div className="relative w-80">
              <Search className="absolute right-3 top-3 h-5 w-5 text-gray-400" />
              <input
                type="text"
                placeholder="البحث عن موظف..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="w-full border border-gray-300 rounded-lg py-3 px-10 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
          </div>

          {/* Employees Grid */}
          {loading ? (
            <div className="text-center py-20">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
              <p className="mt-4 text-gray-600">جاري التحميل...</p>
            </div>
          ) : filteredEmployees.length === 0 ? (
            <div className="text-center py-20">
              <User className="mx-auto text-gray-400 mb-4" size={64} />
              <p className="text-xl text-gray-600">لا يوجد موظفين مضافين حالياً</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredEmployees.map((employee) => {
 const monthlyEmployee = Array.isArray(monthlyStatus) ? 
   monthlyStatus.find(emp => emp.EmployeeId === employee.EmployeeId) : 
   null;
 
 return (
   <div key={employee.EmployeeId} className="bg-gray-50 rounded-lg p-6 border hover:shadow-md transition-shadow">
     <div className="flex justify-between items-start mb-4">
       <div className="flex items-center gap-3">
         <div className="relative">
         {employee.ProfileImageBase64 ? (
  <img 
    src={employee.ProfileImageBase64}
    alt={employee.EmployeeName}
    className="w-12 h-12 rounded-full object-cover border-2 border-blue-600"
  />
) : (
  <div className="bg-blue-600 text-white rounded-full p-2 w-12 h-12 flex items-center justify-center">
    <User size={20} />
  </div>
)}
         </div>
         <div>
           <h3 className="font-bold text-lg text-gray-800">{employee.EmployeeName}</h3>
           <p className="text-gray-600">{employee.Position}</p>
         </div>
       </div>
       <span className={`px-3 py-1 rounded-full text-sm ${
         employee.Status === 'نشط' 
           ? 'bg-green-100 text-green-800' 
           : 'bg-red-100 text-red-800'
       }`}>
         {employee.Status}
       </span>
     </div>
     
     <div className="space-y-2 mb-4">
       <div className="flex items-center gap-2 text-gray-600">
         <DollarSign size={16} />
         <span>الراتب الأساسي: {formatCurrency(employee.BasicSalary)}</span>
       </div>
       {employee.Phone && (
         <div className="flex items-center gap-2 text-gray-600">
           <Phone size={16} />
           <span>{employee.Phone}</span>
         </div>
       )}
       {employee.Email && (
         <div className="flex items-center gap-2 text-gray-600">
           <Mail size={16} />
           <span className="text-sm">{employee.Email}</span>
         </div>
       )}
       
       {monthlyEmployee && (
         <div className="mt-3 p-3 bg-white rounded border">
           <div className="flex items-center justify-between mb-2">
             <span className="text-sm font-medium">حالة الشهر الحالي:</span>
             <span className={`px-2 py-1 rounded-full text-xs ${getStatusColor(monthlyEmployee.PaymentStatus)}`}>
               {monthlyEmployee.PaymentStatus}
             </span>
           </div>
           <div className="text-xs space-y-1">
             <div>المدفوع: {formatCurrency(monthlyEmployee.PaidSalary)}</div>
             {monthlyEmployee.TotalAdvance > 0 && (
               <div className="text-orange-600">السلف: {formatCurrency(monthlyEmployee.TotalAdvance)}</div>
             )}
             {monthlyEmployee.RemainingSalary > 0 && (
               <div className="text-blue-600 font-medium">المبلغ المخصوم : {formatCurrency(monthlyEmployee.RemainingSalary)}</div>
             )}
             {monthlyEmployee.TotalPendingDeductions > 0 && (
               <div className="text-red-600 font-medium flex items-center gap-1">
                 <AlertCircle size={12} />
                 خصومات معلقة: {formatCurrency(monthlyEmployee.TotalPendingDeductions)}
               </div>
             )}
           </div>
         </div>
       )}
     </div>

     <div className="flex gap-2 flex-wrap">
       {monthlyEmployee && monthlyEmployee.RemainingSalary > 0 && canDo('دفع راتب') && (
         <button
           onClick={() => openSmartSalaryForm(employee)}
           className="flex-1 bg-green-600 hover:bg-green-700 text-white py-2 px-3 rounded text-sm transition-colors"
         >
           دفع راتب 
         </button>
       )}
       {canDo('إضافة سلفة') && (
       <button
         onClick={() => openAdvanceForm(employee)}
         className="bg-orange-600 hover:bg-orange-700 text-white p-2 rounded transition-colors"
         title="إضافة سلفة"
       >
         <CreditCard size={16} />
       </button>
       )}
       <button
         onClick={() => openTransactions(employee)}
         className="bg-purple-600 hover:bg-purple-700 text-white p-2 rounded transition-colors"
         title="عرض المعاملات"
       >
         <FileText size={16} />
       </button>
       <button
         onClick={() => openEmployeeHistory(employee)}
         className="bg-indigo-600 hover:bg-indigo-700 text-white p-2 rounded transition-colors"
         title="سجل الموظف"
       >
         <BarChart3 size={16} />
       </button>
       {canDo('تعديل موظف') && (
       <button
         onClick={() => handleEdit(employee)}
         className="bg-blue-600 hover:bg-blue-700 text-white p-2 rounded transition-colors"
       >
         <Edit size={16} />
       </button>
       )}
       {canDo('حذف موظف') && (
       <button
         onClick={() => handleDelete(employee.EmployeeId)}
         className="bg-red-600 hover:bg-red-700 text-white p-2 rounded transition-colors"
       >
         <Trash2 size={16} />
       </button>
       )}
     </div>
   </div>
 );
})}
             
            </div>
          )}
        </div>
      )}

      {/* Reports Tab - كامل */}
      {activeTab === 'reports' && (
        <div className="bg-white rounded-lg shadow-lg p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-3">
              <TrendingUp className="text-green-600" size={28} />
              تقرير الرواتب الشهرية
            </h2>
            <div className="flex gap-4">
              <select
                value={reportMonth}
                onChange={(e) => setReportMonth(parseInt(e.target.value))}
                className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {[...Array(12)].map((_, i) => (
                  <option key={i} value={i + 1}>
                    {getMonthName(i + 1)}
                  </option>
                ))}
              </select>
              <select
                value={reportYear}
                onChange={(e) => setReportYear(parseInt(e.target.value))}
                className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {[...Array(5)].map((_, i) => (
                  <option key={i} value={new Date().getFullYear() - i}>
                    {new Date().getFullYear() - i}
                  </option>
                ))}
              </select>
              <button
                onClick={fetchSalaryReport}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg transition-colors"
              >
                تحديث التقرير
              </button>
            </div>
          </div>

          <div className="employee-desktop-table overflow-x-auto">
            <table className="w-full border-collapse bg-white">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 p-3 text-right">اسم الموظف</th>
                  <th className="border border-gray-300 p-3 text-right">المنصب</th>
                  <th className="border border-gray-300 p-3 text-right">الراتب الأساسي</th>
                  <th className="border border-gray-300 p-3 text-right">الراتب المدفوع</th>
                  <th className="border border-gray-300 p-3 text-right">السلف</th>
                  <th className="border border-gray-300 p-3 text-right">البونصات</th>
                  <th className="border border-gray-300 p-3 text-right">الخصومات</th>
                  <th className="border border-gray-300 p-3 text-right">المتبقي</th>
                </tr>
              </thead>
              <tbody>
                {salaryReport.map((employee) => (
                  <tr key={employee.EmployeeId} className="hover:bg-gray-50">
                    <td className="border border-gray-300 p-3 font-medium">{employee.EmployeeName}</td>
                    <td className="border border-gray-300 p-3">{employee.Position}</td>
                    <td className="border border-gray-300 p-3">{formatCurrency(employee.BasicSalary)}</td>
                    <td className="border border-gray-300 p-3 text-green-600">{formatCurrency(employee.PaidSalary)}</td>
                    <td className="border border-gray-300 p-3 text-orange-600">{formatCurrency(employee.TotalAdvance)}</td>
                    <td className="border border-gray-300 p-3 text-blue-600">{formatCurrency(employee.TotalBonus || 0)}</td>
                    <td className="border border-gray-300 p-3 text-red-600">{formatCurrency(employee.TotalDeduction || 0)}</td>
                    <td className="border border-gray-300 p-3 font-medium">{formatCurrency(employee.RemainingSalary)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="employee-mobile-card-list hidden mt-3 space-y-3">
            {salaryReport.map((employee) => (
              <div key={`mobile-report-${employee.EmployeeId}`} className="employee-mobile-card">
                <div className="flex items-start justify-between gap-2 mb-3">
                  <div>
                    <div className="text-lg font-bold text-gray-900">{employee.EmployeeName}</div>
                    <div className="text-sm text-gray-500">{employee.Position}</div>
                  </div>
                  <span className="bg-green-50 text-green-700 px-3 py-1 rounded-full text-xs font-bold">تقرير راتب</span>
                </div>
                <div className="employee-mobile-kv">
                  <div><div className="employee-mobile-label">الراتب الأساسي</div><div className="employee-mobile-value">{formatCurrency(employee.BasicSalary)}</div></div>
                  <div><div className="employee-mobile-label">المدفوع</div><div className="employee-mobile-value text-green-600">{formatCurrency(employee.PaidSalary)}</div></div>
                  <div><div className="employee-mobile-label">السلف</div><div className="employee-mobile-value text-orange-600">{formatCurrency(employee.TotalAdvance)}</div></div>
                  <div><div className="employee-mobile-label">البونصات</div><div className="employee-mobile-value text-blue-600">{formatCurrency(employee.TotalBonus || 0)}</div></div>
                  <div><div className="employee-mobile-label">الخصومات</div><div className="employee-mobile-value text-red-600">{formatCurrency(employee.TotalDeduction || 0)}</div></div>
                  <div><div className="employee-mobile-label">المتبقي</div><div className="employee-mobile-value">{formatCurrency(employee.RemainingSalary)}</div></div>
                </div>
              </div>
            ))}
          </div>

        </div>
      )}


{/* All Transactions Tab - سجل المعاملات الشامل */}
{/* All Transactions Tab - سجل المعاملات الشامل */}
{activeTab === 'all-transactions' && (
  <div className="bg-white rounded-lg shadow-lg p-6">
    <div className="flex justify-between items-center mb-6">
      <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-3">
        <FileText className="text-purple-600" size={28} />
        سجل المعاملات الشامل
        {!searchDebounce.trim() && (
          <span className="text-sm font-normal text-gray-500 bg-blue-100 px-2 py-1 rounded">
            آخر 10 معاملات
          </span>
        )}
        {searchDebounce.trim() && (
          <span className="text-sm font-normal text-gray-500 bg-green-100 px-2 py-1 rounded">
            نتائج البحث: {allTransactionsData.totalCount}
          </span>
        )}
      </h2>

    </div>

    {/* أدوات البحث والفلترة المحدثة */}
    <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6">
      <div className="relative">
        <Search className="absolute right-3 top-3 h-5 w-5 text-gray-400" />
        <input
          type="text"
          placeholder="البحث في المعاملات..."
          value={transactionSearch}
          onChange={(e) => setTransactionSearch(e.target.value)}
          className="w-full border border-gray-300 rounded-lg py-3 px-10 focus:outline-none focus:ring-2 focus:ring-purple-500"
        />
      </div>
      
      <select
        value={employeeFilter}
        onChange={(e) => setEmployeeFilter(e.target.value)}
        className="border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-purple-500"
      >
        <option value="الكل">جميع الموظفين</option>
        {employees.map(emp => (
          <option key={emp.EmployeeId} value={emp.EmployeeId}>
            {emp.EmployeeName}
          </option>
        ))}
      </select>
      
      <select
        value={transactionFilter}
        onChange={(e) => setTransactionFilter(e.target.value)}
        className="border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-purple-500"
      >
        <option value="الكل">جميع الأنواع</option>
        <option value="راتب">راتب</option>
        <option value="بونص">بونص</option>
        <option value="خصم">خصم</option>
        <option value="سلفة">سلفة</option>
        <option value="دفع قسط">دفع قسط</option>
      </select>
      
      <input
        type="date"
        value={dateFilter}
        onChange={(e) => setDateFilter(e.target.value)}
        className="border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-purple-500"
        placeholder="فلترة بالتاريخ"
      />
      
      <button
        onClick={() => {
          setTransactionSearch('');
          setTransactionFilter('الكل');
          setEmployeeFilter('الكل');
          setDateFilter('');
        }}
        className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-3 rounded-lg transition-colors"
      >
        إعادة تعيين
      </button>
    </div>

    {/* رسالة توضيحية */}
    <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
      <p className="text-sm text-blue-700">
        💡 <strong>تلميح:</strong> 
        {!searchDebounce.trim() ? 
          'يتم عرض آخر 10 معاملات فقط. استخدم البحث للعثور على معاملات أقدم.' :
          `يتم البحث في جميع المعاملات. تم العثور على ${allTransactionsData.totalCount} نتيجة.`
        }
      </p>
    </div>

    {/* جدول المعاملات */}
    {loading ? (
      <div className="text-center py-20">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">جاري التحميل...</p>
      </div>
    ) : filteredTransactions.length === 0 ? (
      <div className="text-center py-20">
        <FileText className="mx-auto text-gray-400 mb-4" size={64} />
        <p className="text-xl text-gray-600">
          {searchDebounce.trim() ? 'لا توجد معاملات مطابقة للبحث' : 'لا توجد معاملات'}
        </p>
      </div>
    ) : (
      <>
        <div className="bg-white rounded-lg shadow overflow-hidden">
          <div className="employee-desktop-table overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gradient-to-r from-purple-600 to-purple-700 text-white">
                <tr>
                  <th className="px-4 py-4 text-right text-sm font-semibold">التاريخ</th>
                  <th className="px-4 py-4 text-right text-sm font-semibold">الموظف</th>
                  <th className="px-4 py-4 text-right text-sm font-semibold">المنصب</th>
                  <th className="px-4 py-4 text-right text-sm font-semibold">نوع المعاملة</th>
                  <th className="px-4 py-4 text-right text-sm font-semibold">المبلغ</th>
                  <th className="px-4 py-4 text-right text-sm font-semibold">طريقة الدفع</th>
                  <th className="px-4 py-4 text-right text-sm font-semibold">الوصف</th>
                  <th className="px-4 py-4 text-right text-sm font-semibold">الشهر/السنة</th>
                  <th className="px-4 py-4 text-right text-sm font-semibold">أضيف بواسطة</th>
                  <th className="px-4 py-4 text-right text-sm font-semibold">حالة التطبيق</th>
                  <th className="px-4 py-4 text-right text-sm font-semibold">الإجراءات</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {filteredTransactions.map((transaction, index) => (
                  <tr 
                    key={transaction.TransactionId} 
                    className={`hover:bg-gray-50 transition-colors ${
                      index % 2 === 0 ? 'bg-white' : 'bg-gray-25'
                    }`}
                  >
                    {/* باقي محتوى الجدول كما هو موجود حالياً */}
                    <td className="px-4 py-4">
                      <div className="text-sm font-medium text-gray-900">
                        {formatDate(transaction.TransactionDate)}
                      </div>
                      <div className="text-xs text-gray-500">
                        {new Date(transaction.TransactionDate).toLocaleTimeString('ar-EG', {
                          hour: '2-digit',
                          minute: '2-digit'
                        })}
                      </div>
                    </td>
                    <td className="px-4 py-4">
                      <div className="flex items-center">
                        <div className="flex-shrink-0 w-8 h-8">
                          <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                            <User size={16} className="text-blue-600" />
                          </div>
                        </div>
                        <div className="mr-3">
                          <div className="text-sm font-medium text-gray-900">
                            {transaction.EmployeeName}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-4 py-4">
                      <div className="text-sm text-gray-600">
                        {transaction.Position}
                      </div>
                    </td>
                    <td className="px-4 py-4">
                      <div className="flex flex-col gap-1">
                        <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
                          transaction.TransactionType === 'راتب' 
                            ? 'bg-green-100 text-green-800'
                            : transaction.TransactionType === 'سلفة'
                            ? 'bg-orange-100 text-orange-800'
                            : transaction.TransactionType === 'بونص'
                            ? 'bg-blue-100 text-blue-800'
                            : transaction.TransactionType === 'دفع قسط'
                            ? 'bg-purple-100 text-purple-800'
                            : 'bg-red-100 text-red-800'
                        }`}>
                          {transaction.TransactionType}
                        </span>
                        {transaction.TransactionType === 'بونص' && (
                          <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs ${
                            transaction.PaymentMethodId 
                              ? 'bg-green-50 text-green-700 border border-green-200' 
                              : 'bg-yellow-50 text-yellow-700 border border-yellow-200'
                          }`}>
                            {transaction.PaymentMethodId ? '💰 مباشر' : '📅 مع الراتب'}
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="px-4 py-4">
                      <div className={`text-sm font-bold ${
                        ['راتب', 'بونص', 'سلفة'].includes(transaction.TransactionType)
                          ? 'text-red-600'
                          : 'text-green-600'
                      }`}>
                        {formatCurrency(transaction.Amount)}
                      </div>
                      <div className="text-xs text-gray-500">
                        {['راتب', 'بونص', 'سلفة'].includes(transaction.TransactionType) ? '📤 مصروف' : '📥 إيراد'}
                      </div>
                    </td>
                    <td className="px-4 py-4">
                      <div className="text-sm">
                        {transaction.PaymentMethodId ? (
                          <div 
                            className="space-y-1 cursor-help"
                            title={`طريقة الدفع: ${transaction.PaymentMethodName}\nرقم الحساب: ${transaction.PaymentMethodAccount}\nالبنك: ${transaction.PaymentMethodBank}`}
                          >
                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-50 text-blue-800 border border-blue-200">
                              🏦 {transaction.PaymentMethodName || 'بنكي'}
                            </span>
                            <div className="text-xs text-gray-500 truncate max-w-20">
                              {transaction.PaymentMethodAccount}
                            </div>
                          </div>
                        ) : transaction.TransactionType === 'خصم' ? (
                          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-gray-50 text-gray-600 border border-gray-200">
                            ⏳ معلق
                          </span>
                        ) : (
                          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-green-50 text-green-700 border border-green-200">
                            💵 نقدي
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="px-4 py-4">
                      <div className="text-sm text-gray-900 max-w-xs">
                        <div className="truncate" title={transaction.Description}>
                          {transaction.Description}
                        </div>
                      </div>
                    </td>
                    <td className="px-4 py-4">
                      <div className="text-sm text-gray-600">
                        {transaction.SalaryMonth && transaction.SalaryYear 
                          ? (
                            <span className="inline-flex items-center px-2 py-1 rounded bg-gray-100 text-gray-800">
                              {getMonthName(transaction.SalaryMonth)} {transaction.SalaryYear}
                            </span>
                          )
                          : <span className="text-gray-400">-</span>
                        }
                      </div>
                    </td>
                    <td className="px-4 py-4">
                      <div className="text-sm text-gray-600">
                        {transaction.CreatedByFullName || transaction.CreatedBy
}
                      </div>
                    </td>
                    <td className="px-4 py-4">
                      {transaction.TransactionType === 'خصم' ? (
                        <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                          transaction.IsApplied 
                            ? 'bg-green-100 text-green-800' 
                            : 'bg-yellow-100 text-yellow-800'
                        }`}>
                          {transaction.IsApplied ? '✅ مطبق' : '⏳ معلق'}
                        </span>
                      ) : (
                        <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                          ✅ مطبق
                        </span>
                      )}
                    </td>
                    <td className="px-4 py-4">
                      <div className="flex items-center gap-2">
                        {canDo('تعديل معاملة') && transaction.TransactionType !== 'سلفة' && 
                         transaction.TransactionType !== 'دفع قسط' && 
                         transaction.TransactionType !== 'راتب' ? (
                          <button
                            onClick={() => openEditTransactionForm(transaction)}
                            className="text-blue-600 hover:text-blue-800 transition-colors p-1 rounded hover:bg-blue-50"
                            title="تعديل"
                          >
                            <Edit size={16} />
                          </button>
                        ) : canDo('تعديل معاملة') ? (
                          <button
                            disabled
                            className="text-gray-300 cursor-not-allowed p-1"
                            title={
                              transaction.TransactionType === 'راتب' 
                                ? 'لا يمكن تعديل معاملات الراتب' 
                                : transaction.TransactionType === 'سلفة'
                                ? 'لا يمكن تعديل السلف من هنا'
                                : 'لا يمكن تعديل الأقساط من هنا'
                            }
                          >
                            <Edit size={16} />
                          </button>
                        ) : null}
                        
                        {canDo('حذف معاملة') && (
                        <button
                          onClick={() => handleDeleteTransactionFromAll(transaction.TransactionId, transaction.TransactionType)}
                          className="text-red-600 hover:text-red-800 transition-colors p-1 rounded hover:bg-red-50"
                          title={
                            transaction.TransactionType === 'راتب' 
                              ? 'حذف معاملة الراتب (سيتم إرجاع الخصومات)' 
                              : transaction.TransactionType === 'سلفة'
                              ? 'حذف السلفة كاملة'
                              : transaction.TransactionType === 'دفع قسط'
                              ? 'إلغاء دفع القسط'
                              : 'حذف'
                          }
                        >
                          <Trash2 size={16} />
                        </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="employee-mobile-card-list hidden mt-3 space-y-3">
            {filteredTransactions.map((transaction) => (
              <div key={`mobile-all-transaction-${transaction.TransactionId}`} className="employee-mobile-card">
                <div className="flex items-start justify-between gap-3 mb-3">
                  <div>
                    <div className="text-lg font-bold text-gray-900">{transaction.EmployeeName}</div>
                    <div className="text-sm text-gray-500">{transaction.Position || '-'}</div>
                  </div>
                  <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-bold ${
                    transaction.TransactionType === 'راتب' 
                      ? 'bg-green-100 text-green-800'
                      : transaction.TransactionType === 'سلفة'
                      ? 'bg-orange-100 text-orange-800'
                      : transaction.TransactionType === 'بونص'
                      ? 'bg-blue-100 text-blue-800'
                      : transaction.TransactionType === 'دفع قسط'
                      ? 'bg-purple-100 text-purple-800'
                      : 'bg-red-100 text-red-800'
                  }`}>
                    {transaction.TransactionType}
                  </span>
                </div>
                <div className="employee-mobile-kv mb-3">
                  <div><div className="employee-mobile-label">التاريخ</div><div className="employee-mobile-value">{formatDate(transaction.TransactionDate)}</div></div>
                  <div><div className="employee-mobile-label">المبلغ</div><div className={`employee-mobile-value ${['راتب', 'بونص', 'سلفة'].includes(transaction.TransactionType) ? 'text-red-600' : 'text-green-600'}`}>{formatCurrency(transaction.Amount)}</div></div>
                  <div><div className="employee-mobile-label">طريقة الدفع</div><div className="employee-mobile-value">{transaction.PaymentMethodName || (transaction.TransactionType === 'خصم' ? 'معلق' : 'نقدي')}</div></div>
                  <div><div className="employee-mobile-label">الشهر / السنة</div><div className="employee-mobile-value">{transaction.SalaryMonth && transaction.SalaryYear ? `${getMonthName(transaction.SalaryMonth)} ${transaction.SalaryYear}` : '-'}</div></div>
                </div>
                {transaction.Description && (
                  <div className="bg-gray-50 rounded-xl p-3 text-sm text-gray-700 mb-3">
                    {transaction.Description}
                  </div>
                )}
                <div className="flex items-center justify-between gap-2 border-t pt-3">
                  <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${transaction.TransactionType === 'خصم' && !transaction.IsApplied ? 'bg-yellow-100 text-yellow-800' : 'bg-blue-100 text-blue-800'}`}>
                    {transaction.TransactionType === 'خصم' ? (transaction.IsApplied ? '✅ مطبق' : '⏳ معلق') : '✅ مطبق'}
                  </span>
                  <div className="flex gap-2">
                    {canDo('تعديل معاملة') && transaction.TransactionType !== 'سلفة' && transaction.TransactionType !== 'دفع قسط' && transaction.TransactionType !== 'راتب' && (
                      <button onClick={() => openEditTransactionForm(transaction)} className="bg-blue-50 text-blue-700 px-3 py-2 rounded-xl text-sm font-bold flex items-center gap-2">
                        <Edit size={16} /> تعديل
                      </button>
                    )}
                    {canDo('حذف معاملة') && (
                      <button onClick={() => handleDeleteTransactionFromAll(transaction.TransactionId, transaction.TransactionType)} className="bg-red-50 text-red-700 px-3 py-2 rounded-xl text-sm font-bold flex items-center gap-2">
                        <Trash2 size={16} /> حذف
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          
          {/* إجمالي النتائج المحسن */}
          <div className="bg-gray-50 px-6 py-4 border-t">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div className="text-center">
                <div className="text-lg font-bold text-gray-900">{filteredTransactions.length}</div>
                <div className="text-sm text-gray-600">المعاملات المعروضة</div>
              </div>
              <div className="text-center">
                <div className="text-lg font-bold text-blue-600">
                  {formatCurrency(filteredTransactions.reduce((sum, t) => sum + t.Amount, 0))}
                </div>
                <div className="text-sm text-gray-600">إجمالي المبالغ</div>
              </div>
              <div className="text-center">
                <div className="text-lg font-bold text-purple-600">
                  {new Set(filteredTransactions.map(t => t.EmployeeId)).size}
                </div>
                <div className="text-sm text-gray-600">عدد الموظفين</div>
              </div>
              <div className="text-center">
                <div className="text-lg font-bold text-orange-600">
                  {allTransactionsData.totalCount || 0}
                </div>
                <div className="text-sm text-gray-600">إجمالي في قاعدة البيانات</div>
              </div>
            </div>
          </div>
        </div>
        
        {/* زر تحميل المزيد */}
        {allTransactionsData.hasMore && !searchDebounce.trim() && (
          <div className="text-center mt-6">
            <button
              onClick={loadMoreTransactions}
              disabled={isLoadingMore}
              className={`px-6 py-3 rounded-lg transition-colors ${
                isLoadingMore 
                  ? 'bg-gray-400 cursor-not-allowed text-white' 
                  : 'bg-purple-600 hover:bg-purple-700 text-white'
              }`}
            >
              {isLoadingMore ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white inline-block ml-2"></div>
                  جاري التحميل...
                </>
              ) : (
                `تحميل المزيد (${allTransactionsData.totalCount - filteredTransactions.length} متبقي)`
              )}
            </button>
          </div>
        )}
      </>
    )}
  </div>
)}

{/* Edit Transaction Modal */}
{showEditTransactionForm && (
  <div className="employee-mobile-modal fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold text-gray-800">تعديل المعاملة</h2>
        <button onClick={resetEditTransactionForm} className="text-gray-500 hover:text-gray-700">
          <X size={24} />
        </button>
      </div>
      
      <form onSubmit={handleEditTransactionSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">اسم الموظف</label>
          <input
            type="text"
            value={editingTransaction?.EmployeeName || ''}
            disabled
            className="w-full border border-gray-300 rounded-lg p-3 bg-gray-100 text-gray-600"
          />
        </div>

        {/* نوع المعاملة - للقراءة فقط */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">نوع المعاملة</label>
          <input
            type="text"
            value={editTransactionFormData.transactionType}
            disabled
            className="w-full border border-gray-300 rounded-lg p-3 bg-gray-100 text-gray-600"
          />
          <p className="text-xs text-gray-500 mt-1">لا يمكن تعديل نوع المعاملة لأسباب محاسبية</p>
        </div>

        {/* نوع البونص - مُصحح */}
        {editTransactionFormData.transactionType === 'بونص' && (
          <>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">نوع البونص</label>
              <select
                value={editTransactionFormData.bonusType || 'with_salary'}
                onChange={(e) => {
                  const newBonusType = e.target.value;
                  setEditTransactionFormData({
                    ...editTransactionFormData, 
                    bonusType: newBonusType,
                    // إذا اختار "مع الراتب"، امسح طريقة الدفع
                    paymentMethodId: newBonusType === 'with_salary' ? null : editTransactionFormData.paymentMethodId,
                    paymentMethodType: newBonusType === 'with_salary' ? null : editTransactionFormData.paymentMethodType
                  });
                }}
                className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="with_salary">مع الراتب (يُحسب عند دفع الراتب)</option>
                <option value="direct">تحويل مباشر (من البنك فوراً)</option>
              </select>
            </div>

            {/* طريقة الدفع للبونص المباشر */}
            {editTransactionFormData.bonusType === 'direct' && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">طريقة الدفع</label>
                <select
                  value={editTransactionFormData.paymentMethodId || ''}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    const selectedMethod = paymentMethods.find(pm => pm.id == selectedId);
                    setEditTransactionFormData({
                      ...editTransactionFormData,
                      paymentMethodId: selectedId ? parseInt(selectedId) : null,
                      paymentMethodType: selectedMethod ? selectedMethod.type : null
                    });
                  }}
                  className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                >
                  <option value="">اختر طريقة الدفع</option>
                  {paymentMethods.map(method => (
                    <option key={method.id} value={method.id}>
                      {method.Name} - {method.AccountNumber}
                      {method.categoryName && ` (${method.categoryName})`}
                    </option>
                  ))}
                </select>
                <p className="text-xs text-gray-500 mt-1">
                  سيتم تحديث المعاملة البنكية المرتبطة
                </p>
              </div>
            )}

            {/* رسالة توضيحية */}
            <div className={`p-3 rounded-lg border ${
              editTransactionFormData.bonusType === 'direct' 
                ? 'bg-blue-50 border-blue-200' 
                : 'bg-yellow-50 border-yellow-200'
            }`}>
              <p className={`text-sm ${
                editTransactionFormData.bonusType === 'direct' 
                  ? 'text-blue-800' 
                  : 'text-yellow-800'
              }`}>
                {editTransactionFormData.bonusType === 'direct' 
                  ? '💰 سيتم خصم المبلغ من البنك فوراً ولن يُحسب مع الراتب'
                  : '📅 سيُحسب مع الراتب ولن يتم خصم أي مبلغ من البنك الآن'
                }
              </p>
            </div>
          </>
        )}
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">تاريخ المعاملة</label>
          <input
            type="date"
            value={editTransactionFormData.transactionDate}
            onChange={(e) => setEditTransactionFormData({...editTransactionFormData, transactionDate: e.target.value})}
            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">المبلغ</label>
          <input
            type="number"
            step="0.01"
            value={editTransactionFormData.amount}
            onChange={(e) => setEditTransactionFormData({...editTransactionFormData, amount: e.target.value})}
            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">الوصف</label>
          <textarea
            value={editTransactionFormData.description}
            onChange={(e) => setEditTransactionFormData({...editTransactionFormData, description: e.target.value})}
            className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            rows="3"
            required
          />
        </div>

        {editTransactionFormData.transactionType === 'راتب' && (
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">شهر الراتب</label>
              <select
                value={editTransactionFormData.salaryMonth}
                onChange={(e) => setEditTransactionFormData({...editTransactionFormData, salaryMonth: parseInt(e.target.value)})}
                className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {[...Array(12)].map((_, i) => (
                  <option key={i} value={i + 1}>
                    {getMonthName(i + 1)}
                  </option>
                ))}
              </select>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">سنة الراتب</label>
              <select
                value={editTransactionFormData.salaryYear}
                onChange={(e) => setEditTransactionFormData({...editTransactionFormData, salaryYear: parseInt(e.target.value)})}
                className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {[...Array(3)].map((_, i) => (
                  <option key={i} value={new Date().getFullYear() - i}>
                    {new Date().getFullYear() - i}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}

        <div className="flex justify-end gap-4 pt-4">
          <button
            type="submit"
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg flex items-center gap-2 transition-colors"
          >
            <Save size={20} />
            حفظ التعديلات
          </button>
          <button
            type="button"
            onClick={resetEditTransactionForm}
            className="border border-gray-300 hover:bg-gray-50 text-gray-700 px-6 py-3 rounded-lg transition-colors"
          >
            إلغاء
          </button>
        </div>
      </form>
    </div>
  </div>
)}




    </div>
  );
};

export default EmployeeManagement;